<template>
  <div :class="componentClassName">
    <a-page-heading>企業情報管理</a-page-heading>
    <m-section>
      <m-action-card title="企業情報編集" :header-border="true" :narrow-body="true">
        <form ref="form" class="t-setting-companys-edit__form" @submit.prevent="handleFormSubmit">
          <div v-if="companyInfoData" class="t-settings-companys-add__fields">
            <m-form-input label="更新履歴">
              <template v-for="(document, index) in formData.documents" :key="index">
                <m-form-input>
                  <a-select-field
                    id="updateHistory"
                    v-model="document.type"
                    placeholder="選択してください"
                    :options="historyList"
                    @change="change_history"
                  />
                </m-form-input>
              </template>
            </m-form-input>

            <m-form-input label="対象サービス">
              <a-text-field
                id="targetService"
                v-model="companyInfoData.voicedxOnlyFlagView"
                type="text"
                :disabled="true"
              />
            </m-form-input>
            <m-form-input label="顧客ID">
              <a-text-field
                id="customerID"
                v-model="companyInfoData.customerID"
                type="text"
                maxlength="10"
                pattern="[0-9a-zA-Z]+"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input label="個人名義・法人名義">
              <template v-for="(document, index) in formData.documents" :key="index">
                <m-form-input>
                  <a-select-field
                    id="nameType"
                    v-model="companyInfoData.businessType"
                    placeholder="選択してください"
                    :options="businessTypeList"
                    :disabled="!flag || readOnly"
                  />
                </m-form-input>
              </template>
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="取引種別">
              <a-select-field
                id="inPersonTransactionFlagList"
                v-model="companyInfoData.inPersonTransactionFlag"
                :options="inPersonTransactionFlagList"
                :show-arrow="true"
                :disabled="!flag || readOnly"
              />
            </m-form-input>

            <br />
            <p>法人情報</p>
            <m-form-input label="契約名義">
              <a-text-field
                id="name"
                v-model="companyInfoData.companyName"
                type="text"
                placeholder="入力してください"
                maxlength="40"
                :disabled="!flag || companyInfoData.businessType !== 'company' || readOnly"
              />
            </m-form-input>
            <m-form-input label="契約名義カナ">
              <a-text-field
                id="nameKana"
                v-model="companyInfoData.companyKanaName"
                type="text"
                placeholder="全角カタカナ"
                maxlength="40"
                pattern="[ァ-ヶー 　]+"
                :disabled="!flag || companyInfoData.businessType !== 'company' || readOnly"
              />
            </m-form-input>
            <m-form-input label="郵便番号">
              <a-text-field
                id="postalCode"
                v-model="companyInfoData.companyPostCode"
                type="text"
                placeholder="ハイフンなし"
                maxlength="7"
                pattern="[0-9]{7}"
                :disabled="!flag || companyInfoData.businessType !== 'company' || readOnly"
              />
            </m-form-input>
            <m-form-input label="都道府県名">
              <a-select-field
                id="-prefectures"
                v-model="companyInfoData.companyAddress1"
                required
                :options="prefectures"
                :tabopen="tabopen"
                :disabled="!flag || companyInfoData.businessType !== 'company' || readOnly"
              />
            </m-form-input>
            <m-form-input label="市区町村">
              <a-text-field
                id="municipalities"
                v-model="companyInfoData.companyAddress2"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                :disabled="!flag || companyInfoData.businessType !== 'company' || readOnly"
              />
            </m-form-input>
            <m-form-input label="字丁目番地など">
              <a-text-field
                id="chome"
                v-model="companyInfoData.companyAddress3"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                :disabled="!flag || companyInfoData.businessType !== 'company' || readOnly"
              />
            </m-form-input>
            <m-form-input label="住所建物など">
              <a-text-field
                id="building"
                v-model="companyInfoData.companyAddress4"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                :disabled="!flag || companyInfoData.businessType !== 'company' || readOnly"
              />
            </m-form-input>
            <m-form-input label="事業内容">
              <a-text-field
                id="businessContent"
                v-model="companyInfoData.companyBusinessDetails"
                type="text"
                placeholder="入力してください"
                maxlength="100"
                :disabled="!flag || companyInfoData.businessType !== 'company' || readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="法人番号">
              <a-text-field
                id="companyNumber"
                v-model="companyInfoData.companyNumber"
                type="text"
                placeholder=""
                maxlength="13"
                pattern="[0-9]+"
                :disabled="!flag || companyInfoData.businessType !== 'company' || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者の有無">
              <a-radio
                id="ownerNotExist"
                v-model="radio"
                name="flag"
                value="false"
                label="無"
                :disabled="!flag || companyInfoData.businessType !== 'company' || readOnly"
              />
              <a-radio
                id="ownerExist"
                v-model="radio"
                name="flag"
                value="true"
                label="有"
                :disabled="!flag || companyInfoData.businessType !== 'company' || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者名">
              <a-text-field
                id="ownerName"
                v-model="companyInfoData.companyRulerName"
                type="text"
                placeholder=""
                maxlength="40"
                :disabled="!flag || companyInfoData.businessType !== 'company' || radio !== 'true' || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者住所">
              <a-text-field
                id="ownerAddress"
                v-model="companyInfoData.companyRulerAddress"
                type="text"
                placeholder=""
                maxlength="80"
                :disabled="!flag || companyInfoData.businessType !== 'company' || radio !== 'true' || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者生年月日">
              <a-text-field
                id="ownerBirthDay"
                v-model="companyInfoData.companyRulerBirthDate"
                type="text"
                placeholder="YYYYMMDD"
                maxlength="8"
                pattern="[0-9]{8}"
                :disabled="!flag || companyInfoData.businessType !== 'company' || radio !== 'true' || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者の法人との関係">
              <a-text-field
                id="relationshipWithOwner"
                v-model="companyInfoData.companyRelationship"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="!flag || companyInfoData.businessType !== 'company' || radio !== 'true' || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者名2">
              <a-text-field
                id="ownerName2"
                v-model="companyInfoData.companyRulerName2"
                type="text"
                placeholder=""
                maxlength="40"
                :disabled="!flag || companyInfoData.businessType !== 'company' || radio !== 'true' || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者住所2">
              <a-text-field
                id="ownerAddress2"
                v-model="companyInfoData.companyRulerAddress2"
                type="text"
                placeholder=""
                maxlength="80"
                :disabled="!flag || companyInfoData.businessType !== 'company' || radio !== 'true' || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者生年月日2">
              <a-text-field
                id="ownerBirthDay2"
                v-model="companyInfoData.companyRulerBirthDate2"
                type="text"
                placeholder="YYYYMMDD"
                maxlength="8"
                pattern="[0-9]{8}"
                :disabled="!flag || companyInfoData.businessType !== 'company' || radio !== 'true' || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者の法人との関係2">
              <a-text-field
                id="relationshipWithOwner2"
                v-model="companyInfoData.companyRelationship2"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="!flag || companyInfoData.businessType !== 'company' || radio !== 'true' || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者名3">
              <a-text-field
                id="ownerName3"
                v-model="companyInfoData.companyRulerName3"
                type="text"
                placeholder=""
                maxlength="40"
                :disabled="!flag || companyInfoData.businessType !== 'company' || radio !== 'true' || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者住所3">
              <a-text-field
                id="ownerAddress3"
                v-model="companyInfoData.companyRulerAddress3"
                type="text"
                placeholder=""
                maxlength="80"
                :disabled="!flag || companyInfoData.businessType !== 'company' || radio !== 'true' || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者生年月日3">
              <a-text-field
                id="ownerBirthDay3"
                v-model="companyInfoData.companyRulerBirthDate3"
                type="text"
                placeholder="YYYYMMDD"
                maxlength="8"
                pattern="[0-9]{8}"
                :disabled="!flag || companyInfoData.businessType !== 'company' || radio !== 'true' || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者の法人との関係3">
              <a-text-field
                id="relationshipWithOwner3"
                v-model="companyInfoData.companyRelationship3"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="!flag || companyInfoData.businessType !== 'company' || radio !== 'true' || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者名4">
              <a-text-field
                id="ownerName4"
                v-model="companyInfoData.companyRulerName4"
                type="text"
                placeholder=""
                maxlength="40"
                :disabled="!flag || companyInfoData.businessType !== 'company' || radio !== 'true' || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者住所4">
              <a-text-field
                id="ownerAddress4"
                v-model="companyInfoData.companyRulerAddress4"
                type="text"
                placeholder=""
                maxlength="80"
                :disabled="!flag || companyInfoData.businessType !== 'company' || radio !== 'true' || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者生年月日4">
              <a-text-field
                id="ownerBirthDay4"
                v-model="companyInfoData.companyRulerBirthDate4"
                type="text"
                placeholder="YYYYMMDD"
                maxlength="8"
                pattern="[0-9]{8}"
                :disabled="!flag || companyInfoData.businessType !== 'company' || radio !== 'true' || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者の法人との関係4">
              <a-text-field
                id="relationshipWithOwner4"
                v-model="companyInfoData.companyRelationship4"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="!flag || companyInfoData.businessType !== 'company' || radio !== 'true' || readOnly"
              />
            </m-form-input>
            <br />
            <p>マスタ管理者</p>
            <m-form-input label="氏名">
              <a-text-field
                id="masterAdminLastName"
                v-model="companyInfoData.adminLastName"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                required
                :disabled="!flag || readOnly"
              />
              <a-text-field
                id="masterAdminFirstName"
                v-model="companyInfoData.adminName"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                required
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input label="氏名カナ">
              <a-text-field
                id="masterAdminLastNameKana"
                v-model="companyInfoData.adminLastKanaName"
                type="text"
                placeholder="全角カタカナ"
                pattern="[ァ-ヶー]+"
                maxlength="20"
                required
                :disabled="!flag || readOnly"
              />
              <a-text-field
                id="masterAdminFirstNameKana"
                v-model="companyInfoData.adminKanaName"
                type="text"
                placeholder="全角カタカナ"
                pattern="[ァ-ヶー]+"
                maxlength="20"
                required
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input label="生年月日">
              <a-text-field
                id="masterAdminBirthDay"
                v-model="companyInfoData.adminBirthDate"
                type="text"
                placeholder="YYYYMMDD"
                maxlength="8"
                pattern="[0-9]{8}"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input label="メールアドレス">
              <a-text-field
                id="masterAdminMailAddress"
                v-model="companyInfoData.adminEmail"
                type="email"
                placeholder="キャリアメールは使えません"
                maxlength="50"
                required
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input label="職業">
              <a-text-field
                id="masterAdminJob"
                v-model="companyInfoData.adminJob"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                required
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input label="電話番号">
              <a-text-field
                id="masterAdminTelNumber"
                v-model="companyInfoData.adminPhoneNumber"
                type="tel"
                placeholder="ハイフンなし"
                maxlength="11"
                pattern="[0-9]{10,11}"
                required
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input label="郵便番号">
              <a-text-field
                id="masterAdminPostalCode"
                v-model="companyInfoData.adminPostCode"
                type="text"
                placeholder="ハイフンなし"
                maxlength="7"
                pattern="[0-9]{7}"
                required
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input label="都道府県名">
              <a-select-field
                id="-masterAdminPrefectures"
                v-model="companyInfoData.adminAddress1"
                required
                :options="prefectures"
                :tabopen="tabopen"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input label="市区町村">
              <a-text-field
                id="masterAdminMunicipalities"
                v-model="companyInfoData.adminAddress2"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input label="字丁目番地など">
              <a-text-field
                id="masterAdminChome"
                v-model="companyInfoData.adminAddress3"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input label="住所建物など">
              <a-text-field
                id="masterAdminBuilding"
                v-model="companyInfoData.adminAddress4"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                :disabled="!flag || readOnly"
              />
            </m-form-input>

            <br />
            <p>営業担当者情報</p>
            <m-form-input label="販売チャネルコード">
              <a-text-field
                id="masterAdminSalesChannelCode"
                v-model="companyInfoData.salesChannelCode"
                type="text"
                placeholder=""
                maxlength="8"
                pattern="[0-9a-zA-Z]+"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input label="販売担当者コード">
              <a-text-field
                id="masterAdminSalesRepresentativeCode"
                v-model="companyInfoData.salesPersonCode"
                type="text"
                placeholder=""
                maxlength="9"
                pattern="[0-9a-zA-Z]+"
                :disabled="!flag || readOnly"
              />
            </m-form-input>

            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="販売担当者氏名（姓名）">
              <a-text-field
                id="salesPerson"
                v-model="companyInfoData.salesPerson"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="販売担当者氏名カナ（姓名）">
              <a-text-field
                id="salesPersonKanaName"
                v-model="companyInfoData.salesPersonKanaName"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="販売担当者組織/部課名">
              <a-text-field
                id="salesPersonDepartment"
                v-model="companyInfoData.salesPersonDepartment"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="販売担当者メールアドレス">
              <a-text-field
                id="salesPersonEmailAddress"
                v-model="companyInfoData.salesPersonEmailAddress"
                type="email"
                placeholder=""
                maxlength="50"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="販売担当者電話番号">
              <a-text-field
                id="salesPersonPhoneNumber"
                v-model="companyInfoData.salesPersonPhoneNumber"
                type="tel"
                placeholder="ハイフンなし"
                maxlength="11"
                pattern="[0-9]{10,11}"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <br v-if="companyInfoData.voicedxOnlyFlag" />
            <p v-if="companyInfoData.voicedxOnlyFlag">お申し込み対応部門</p>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="お申し込み受付担当者 氏名（姓名）">
              <a-text-field
                id="signupResponderName"
                v-model="companyInfoData.signupResponderName"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="お申し込み受付担当者 氏名カナ（姓名）">
              <a-text-field
                id="signupResponderNameKana"
                v-model="companyInfoData.signupResponderNameKana"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="お申し込み受付担当者 組織/部課名">
              <a-text-field
                id="signupResponderDepartment"
                v-model="companyInfoData.signupResponderDepartment"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="お申し込み受付担当者 メールアドレス">
              <a-text-field
                id="signupResponderMail"
                v-model="companyInfoData.signupResponderMail"
                type="email"
                placeholder=""
                maxlength="50"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="お申し込み受付担当者 電話番号">
              <a-text-field
                id="signupResponderPhoneNumber"
                v-model="companyInfoData.signupResponderPhoneNumber"
                type="tel"
                placeholder="ハイフンなし"
                maxlength="11"
                pattern="[0-9]{10,11}"
                :disabled="!flag || readOnly"
              />
            </m-form-input>

            <br />
            <p>ヒアリング事項</p>
            <m-form-input label="利用目的">
              <div class="a-text-field a-text-field--text" required>
                <textarea
                  id="masterAdminPurposeOfUse"
                  v-model="companyInfoData.purposeOfUse"
                  class="a-text-field__input"
                  placeholder="入力してください"
                  maxlength="100"
                  required
                  :disabled="!flag || readOnly"
                />
              </div>
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="利用予定の電話番号数（ご利用開始から1ヶ月間）">
              <a-text-field
                id="expectedNumberOfPhoneNumber"
                v-model="companyInfoData.expectedNumberOfPhoneNumber"
                type="text"
                placeholder=""
                maxlength="6"
                pattern="[0-9]+"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="利用予定の電話番号数の最大値">
              <a-text-field
                id="expectedMaxNumberOfPhoneNumber"
                v-model="companyInfoData.expectedMaxNumberOfPhoneNumber"
                type="text"
                placeholder=""
                maxlength="6"
                pattern="[0-9]+"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="利用予定の電話発信回数（1ヶ月あたり）の最大値">
              <a-text-field
                id="expectedMaxNumberOfOutgoingCalls"
                v-model="companyInfoData.expectedMaxNumberOfOutgoingCalls"
                type="text"
                placeholder=""
                maxlength="6"
                pattern="[0-9]+"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input
              v-if="companyInfoData.voicedxOnlyFlag === true"
              label="利用予定の電話着信回数（1ヶ月あたり）の最大値"
            >
              <a-text-field
                id="expectedMaxNumberOfIncomingCalls"
                v-model="companyInfoData.expectedMaxNumberOfIncomingCalls"
                type="text"
                placeholder=""
                maxlength="6"
                pattern="[0-9]+"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag === true" label="取引時確認書類の確認日時">
              <a-text-field
                id="documentCheckDay"
                v-model="companyInfoData.documentCheckDay"
                type="text"
                placeholder="yyyymmddHHMM"
                maxlength="12"
                pattern="[0-9]{12}"
                :disabled="!flag || readOnly || companyInfoData.inPersonTransactionFlag !== 'true'"
              />
            </m-form-input>
            <m-form-input
              v-if="companyInfoData.voicedxOnlyFlag === true"
              label="「契約に関する責任者連絡先」欄の確認を行った書類"
            >
              <a-select-field
                id="documentType"
                v-model="companyInfoData.documentType"
                class="a-business-hour-input-field__start"
                :options="documentTypeList"
                :show-arrow="true"
                :disabled="!flag || readOnly || companyInfoData.inPersonTransactionFlag !== 'true'"
              />
            </m-form-input>
            <m-form-input
              v-if="companyInfoData.voicedxOnlyFlag === true"
              label="取引の任に当たっていることを確認した方法"
            >
              <a-select-field
                id="inPersonCertificateTypeList"
                v-model="companyInfoData.inPersonCertificateType"
                class="a-business-hour-input-field__start"
                :options="inPersonCertificateTypeList"
                :show-arrow="true"
                :disabled="!flag || readOnly"
              />
            </m-form-input>

            <br />
            <p>請求書送付先</p>
            <m-form-input label="郵便番号">
              <a-text-field
                id="invoicePostalCode"
                v-model="companyInfoData.invoicePostCode"
                type="text"
                placeholder="ハイフンなし"
                maxlength="7"
                pattern="[0-9]{7}"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input label="都道府県名">
              <a-select-field
                id="-invoicePrefectures"
                v-model="companyInfoData.invoiceAddress1"
                required
                :options="prefectures"
                :tabopen="tabopen"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input label="市区町村">
              <a-text-field
                id="invoiceMunicipalities"
                v-model="companyInfoData.invoiceAddress2"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input label="字丁目番地など">
              <a-text-field
                id="invoiceChome"
                v-model="companyInfoData.invoiceAddress3"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input label="住所建物など">
              <a-text-field
                id="invoiceBuilding"
                v-model="companyInfoData.invoiceAddress4"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <m-form-input label="宛名"></m-form-input>
            <div class="a-invoice-padding">
              <m-form-input label="請求書送付先①カナ(必須)">
                <a-text-field
                  id="invoiceDestinationNameKana"
                  v-model="companyInfoData.invoiceKanaName"
                  type="text"
                  placeholder="入力してください"
                  maxlength="35"
                  :disabled="!flag || readOnly"
                />
              </m-form-input>
              <div class="a-invoice-text-title">
                <span class="a-invoice-text">請求書送付先①②の登録内容: </span>
                {{ invoiceNameData.invoiceNameView }}
              </div>
              <m-form-input label="請求書送付先①(必須)">
                <a-text-field
                  id="invoiceEditCompany"
                  v-model="invoiceNameData.invoiceCompany"
                  type="text"
                  placeholder="変更内容を入力してください。請求書送付先①②ともに変更しない場合は、空欄のまま登録してください（請求書送付先①だけ入力すると、請求書送付先②は削除されます）"
                  maxlength="20"
                  :disabled="!flag || readOnly"
                  :class-custom-placeholder="'a-invoice-input'"
                />
              </m-form-input>
              <m-form-input label="請求書送付先②">
                <a-text-field
                  id="invoiceEditDepartment"
                  v-model="invoiceNameData.invoiceDepartment"
                  type="text"
                  placeholder="変更内容を入力してください。請求書送付先①②ともに変更しない場合は、空欄のまま登録してください（請求書送付先①だけ入力すると、請求書送付先②は削除されます）"
                  maxlength="20"
                  :disabled="!flag || readOnly"
                  :class-custom-placeholder="'a-invoice-input'"
                />
              </m-form-input>
            </div>
            <m-form-input label="電話番号">
              <a-text-field
                id="invoiceTelNumber"
                v-model="companyInfoData.invoicePhoneNumber"
                type="tel"
                placeholder="ハイフンなし"
                maxlength="11"
                pattern="[0-9]{10,11}"
                :disabled="!flag || readOnly"
              />
            </m-form-input>
            <!--
            <m-form-input label="契約ID（必須）">
              <a-text-field v-model="companyInfoData.companyID" type="text" :disabled="true" />
            </m-form-input>
            <m-form-input label="契約企業名（必須）">
              <a-text-field v-model="companyInfoData.companyName" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="顧客ID（任意）">
              <a-text-field v-model="companyInfoData.customerID" type="text" :disabled="true" />
            </m-form-input>
            <m-form-input label="契約名義カナ">
              <a-text-field v-model="companyInfoData.companyKanaName" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="郵便番号">
              <a-text-field v-model="companyInfoData.companyPostCode" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="都道府県名">
              <a-text-field v-model="companyInfoData.companyAddress1" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="町村区">
              <a-text-field v-model="companyInfoData.companyAddress2" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="字丁目番地など">
              <a-text-field v-model="companyInfoData.companyAddress3" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="住所建物など">
              <a-text-field v-model="companyInfoData.companyAddress4" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="事業内容">
              <a-text-field v-model="companyInfoData.companyBusinessDetails" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="実質的支配者の有無">
              <a-text-field v-model="companyInfoData.companyRulerFlag" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="実質的支配者名">
              <a-text-field v-model="companyInfoData.companyRulerName" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="実質的支配者住所">
              <a-text-field v-model="companyInfoData.companyRulerAddress" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="実質的支配者生年月日">
              <a-text-field v-model="companyInfoData.companyRulerBirthDate" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="実質的支配者の法人との関係">
              <a-text-field v-model="companyInfoData.companyRelationship" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="利用目的">
              <a-text-field v-model="companyInfoData.purposeOfUse" type="text" :disabled="!flag" />
            </m-form-input>

            <p>マスタ管理者</p>
            <m-form-input label="所属部署（必須）">
              <a-text-field v-model="companyInfoData.adminDepartment" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="氏名（必須）">
              <a-text-field v-model="companyInfoData.adminName" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="カナ氏名（必須）">
              <a-text-field v-model="companyInfoData.adminKanaName" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="電話番号（必須）">
              <a-text-field v-model="companyInfoData.adminPhoneNumber" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="メールアドレス（必須）">
              <a-text-field v-model="companyInfoData.adminEmail" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="生年月日">
              <a-text-field v-model="companyInfoData.adminBirthDate" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="職業">
              <a-text-field v-model="companyInfoData.adminJob" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="郵便番号">
              <a-text-field v-model="companyInfoData.adminPostCode" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="都道府県名">
              <a-text-field v-model="companyInfoData.adminAddress1" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="市区町村">
              <a-text-field v-model="companyInfoData.adminAddress2" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="字丁目番地など">
              <a-text-field v-model="companyInfoData.adminAddress3" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="住所建物など">
              <a-text-field v-model="companyInfoData.adminAddress4" type="text" :disabled="!flag" />
            </m-form-input>

            <p>請求書送付先</p>
            <m-form-input label="郵便番号（任意）">
              <a-text-field v-model="companyInfoData.invoicePostCode" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="住所１（任意）">
              <a-text-field v-model="companyInfoData.invoiceAddress1" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="住所２（任意）">
              <a-text-field v-model="companyInfoData.invoiceAddress2" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="字丁目番地など（任意）">
              <a-text-field v-model="companyInfoData.invoiceAddress3" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="住所建物など（任意）">
              <a-text-field v-model="companyInfoData.invoiceAddress4" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="氏名（任意）">
              <a-text-field v-model="companyInfoData.invoiceName" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="電話番号（任意）">
              <a-text-field v-model="companyInfoData.invoicePhoneNumber" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="部課名（任意）">
              <a-text-field v-model="companyInfoData.invoiceDepartment" type="text" :disabled="!flag" />
            </m-form-input>
            <m-form-input label="備考/ステータス（任意）">
              <a-text-field v-model="companyInfoData.note" type="text" :disabled="!flag" />
            </m-form-input>
-->
            <br />
            <p>その他</p>
            <m-form-input label="支払い方法">
              <a-text-field
                id="othersPayment"
                v-model="companyInfoData.billType"
                type="text"
                :disabled="!flag || readOnly"
              />
            </m-form-input>

            <m-form-input label="開通希望日">
              <a-text-field
                id="othersDesiredOpeningDate"
                v-model="companyInfoData.openDay"
                type="text"
                placeholder="YYYYMMDD"
                maxlength="8"
                pattern="[0-9]{8}"
                :disabled="!flag || readOnly"
              />
            </m-form-input>

            <m-form-input label="開通日">
              <a-text-field
                id="othersOpeningDate"
                :value="companyInfoData.startDate"
                type="text"
                placeholder="YYYYMMDD"
                maxlength="8"
                pattern="[0-9]{8}"
                :disabled="true"
              />
            </m-form-input>

            <m-form-input label="解約日">
              <a-text-field
                id="othersCancellationDate"
                v-model="companyInfoData.closeDate"
                type="text"
                placeholder="YYYYMMDD"
                maxlength="8"
                pattern="[0-9]{8}"
                :disabled="!flag || readOnly"
              />
            </m-form-input>

            <m-form-input label="契約ステータス">
              <template v-for="(document, index) in formData.documents" :key="index">
                <m-form-input>
                  <a-select-field
                    id="othersContractStatus"
                    v-model="companyInfoData.contractStatus"
                    placeholder="選択してください"
                    :options="contractStatusList"
                    :disabled="!flag || readOnly"
                  />
                </m-form-input>
              </template>
            </m-form-input>

            <m-form-input label="SOステータス">
              <a-text-field id="othersSoStatus" v-model="companyInfoData.soStatusView" type="text" :disabled="true" />
            </m-form-input>

            <!-- <m-form-input label="解約理由">
              <a-text-field v-model="companyInfoData.cancelNumber" type="text" :disabled="true" />
            </m-form-input> -->

            <m-form-input v-if="cancelReasonFlag" label="解約理由">
              <template v-for="(document, index) in formData.documents" :key="index">
                <m-form-input>
                  <a-select-field
                    id="othersReasonForCancellation"
                    v-model="companyInfoData.cancelNumber"
                    placeholder=""
                    :options="reasonList"
                    :disabled="true"
                  />
                </m-form-input>
              </template>
            </m-form-input>

            <m-form-input label="トライアル移行元ID">
              <a-text-field id="trialCompanyID" v-model="trialCompanyID" type="text" :disabled="true" />
            </m-form-input>

            <m-form-input label="備考">
              <div class="a-text-field a-text-field--text">
                <textarea
                  id="othersMemo"
                  v-model="companyInfoData.note"
                  class="a-text-field__input"
                  placeholder=""
                  maxlength="200"
                  :disabled="!flag || readOnly"
                />
              </div>
            </m-form-input>

            <m-form-input label="応対者">
              <a-text-field
                id="othersRespondent"
                v-model="companyInfoData.responderName"
                type="text"
                placeholder=""
                maxlength="41"
                :disabled="!flag || readOnly"
              />
            </m-form-input>

            <m-form-input label="利用停止機能 ON／OFF">
              <a-switch id="companySuspended" v-model="companyInfoData.suspendedDate" />
            </m-form-input>

            <template
              v-if="
                certificateInfo.DriverlicenseURL1 || certificateInfo.DriverlicenseURL2 || certificateInfo.MyNumberURL
              "
            >
              <h3 id="certificateInfoConfirmH3">本人確認書類</h3>
            </template>
            <template v-if="certificateInfo.DriverlicenseURL1">
              <div v-if="!readOnly"><a @click="open_file(certificateInfo.DriverlicenseURL1)">運転免許証1</a></div>
              <div v-if="readOnly">運転免許証1</div>
            </template>
            <template v-if="certificateInfo.DriverlicenseURL2">
              <div v-if="!readOnly"><a @click="open_file(certificateInfo.DriverlicenseURL2)">運転免許証2</a></div>
              <div v-if="readOnly">運転免許証2</div>
            </template>
            <template v-if="certificateInfo.MyNumberURL">
              <div v-if="!readOnly">
                <a id="myNumberURL" @click="open_file(certificateInfo.MyNumberURL)">マイナンバー</a>
              </div>
              <div v-if="readOnly">マイナンバー</div>
            </template>
            <template v-if="certificateInfo.DrivingHistoryURL1">
              <div v-if="!readOnly">
                <a id="drivingHistoryURL1" @click="open_file(certificateInfo.DrivingHistoryURL1)">運転経歴証明書1</a>
              </div>
              <div v-if="readOnly">運転経歴証明書1</div>
            </template>
            <template v-if="certificateInfo.DrivingHistoryURL2">
              <div v-if="!readOnly">
                <a id="drivingHistoryURL2" @click="open_file(certificateInfo.DrivingHistoryURL2)">運転経歴証明書2</a>
              </div>
              <div v-if="readOnly">運転経歴証明書2</div>
            </template>
            <template v-if="certificateInfo.SealRegistrationURL">
              <div v-if="!readOnly">
                <a id="sealRegistrationURL" @click="open_file(certificateInfo.SealRegistrationURL)">印鑑登録証明書</a>
              </div>
              <div v-if="readOnly">印鑑登録証明書</div>
            </template>
            <template v-if="certificateInfo.FamilyRegisterURL">
              <div v-if="!readOnly">
                <a id="familyRegisterURL" @click="open_file(certificateInfo.FamilyRegisterURL)">戸籍の附票</a>
              </div>
              <div v-if="readOnly">戸籍の附票</div>
            </template>
            <template v-if="certificateInfo.CertificateOfResidenceURL">
              <div v-if="!readOnly">
                <a id="certificateOfResidenceURL" @click="open_file(certificateInfo.CertificateOfResidenceURL)"
                  >住民票</a
                >
              </div>
              <div v-if="readOnly">住民票</div>
            </template>

            <template
              v-if="
                certificateInfo.copyOfCompanyRegisterURL1 ||
                certificateInfo.copyOfCompanyRegisterURL2 ||
                certificateInfo.copyOfCompanyRegisterURL3 ||
                certificateInfo.copyOfCompanyRegisterURL4 ||
                certificateInfo.copyOfCompanyRegisterURL5 ||
                certificateInfo.copyOfCompanyRegisterURL6 ||
                certificateInfo.copyOfCompanyRegisterURL7 ||
                certificateInfo.copyOfCompanyRegisterURL8 ||
                certificateInfo.copyOfCompanyRegisterURL9 ||
                certificateInfo.copyOfCompanyRegisterURL10
              "
            >
              <h3 id="certificateInfoH3">登記事項証明書</h3>
            </template>
            <template v-if="certificateInfo.copyOfCompanyRegisterURL1">
              <div v-if="!readOnly">
                <a id="certificateInfoURL1" @click="open_file(certificateInfo.copyOfCompanyRegisterURL1)"
                  >登記事項証明書1</a
                >
              </div>
              <div v-if="readOnly">登記事項証明書1</div>
            </template>
            <template v-if="certificateInfo.copyOfCompanyRegisterURL2">
              <div v-if="!readOnly">
                <a id="certificateInfoURL2" @click="open_file(certificateInfo.copyOfCompanyRegisterURL2)"
                  >登記事項証明書2</a
                >
              </div>
              <div v-if="readOnly">登記事項証明書2</div>
            </template>
            <template v-if="certificateInfo.copyOfCompanyRegisterURL3">
              <div v-if="!readOnly">
                <a id="certificateInfoURL3" @click="open_file(certificateInfo.copyOfCompanyRegisterURL3)"
                  >登記事項証明書3</a
                >
              </div>
              <div v-if="readOnly">登記事項証明書3</div>
            </template>
            <template v-if="certificateInfo.copyOfCompanyRegisterURL4">
              <div v-if="!readOnly">
                <a id="certificateInfoURL4" @click="open_file(certificateInfo.copyOfCompanyRegisterURL4)"
                  >登記事項証明書4</a
                >
              </div>
              <div v-if="readOnly">登記事項証明書4</div>
            </template>
            <template v-if="certificateInfo.copyOfCompanyRegisterURL5">
              <div v-if="!readOnly">
                <a id="certificateInfoURL5" @click="open_file(certificateInfo.copyOfCompanyRegisterURL5)"
                  >登記事項証明書5</a
                >
              </div>
              <div v-if="readOnly">登記事項証明書5</div>
            </template>
            <template v-if="certificateInfo.copyOfCompanyRegisterURL6">
              <div v-if="!readOnly">
                <a id="certificateInfoURL6" @click="open_file(certificateInfo.copyOfCompanyRegisterURL6)"
                  >登記事項証明書6</a
                >
              </div>
              <div v-if="readOnly">登記事項証明書6</div>
            </template>
            <template v-if="certificateInfo.copyOfCompanyRegisterURL7">
              <div v-if="!readOnly">
                <a id="certificateInfoURL7" @click="open_file(certificateInfo.copyOfCompanyRegisterURL7)"
                  >登記事項証明書7</a
                >
              </div>
              <div v-if="readOnly">登記事項証明書7</div>
            </template>
            <template v-if="certificateInfo.copyOfCompanyRegisterURL8">
              <div v-if="!readOnly">
                <a id="certificateInfoURL8" @click="open_file(certificateInfo.copyOfCompanyRegisterURL8)"
                  >登記事項証明書8</a
                >
              </div>
              <div v-if="readOnly">登記事項証明書8</div>
            </template>
            <template v-if="certificateInfo.copyOfCompanyRegisterURL9">
              <div v-if="!readOnly">
                <a id="certificateInfoURL9" @click="open_file(certificateInfo.copyOfCompanyRegisterURL9)"
                  >登記事項証明書9</a
                >
              </div>
              <div v-if="readOnly">登記事項証明書9</div>
            </template>
            <template v-if="certificateInfo.copyOfCompanyRegisterURL10">
              <div v-if="!readOnly">
                <a id="certificateInfoURL10" @click="open_file(certificateInfo.copyOfCompanyRegisterURL10)"
                  >登記事項証明書10</a
                >
              </div>
              <div v-if="readOnly">登記事項証明書10</div>
            </template>

            <template v-if="certificateInfo.letterOfAttorneyURL">
              <h3 id="letterOfAttorneyH3">委任状</h3>
              <div v-if="!readOnly">
                <a id="letterOfAttorneyURL" @click="open_file(certificateInfo.letterOfAttorneyURL)">委任状</a>
              </div>
              <div v-if="readOnly">委任状</div>
            </template>
          </div>

          <m-form-action-buttons>
            <template v-if="!readOnly">
              <a-button
                id="deleteUploadFile"
                variant="outlined"
                color="primary"
                :disabled="!flagAllButtonEnable"
                @click="handleDialogUploadRemove"
                >アップロードファイル削除</a-button
              >
              <a-button
                v-if="companyInfoData"
                id="store"
                variant="block"
                color="primary"
                :disabled="!flag"
                @click="handleDialogCompanyUpdate"
                >保存</a-button
              >
            </template>
            <a-button id="cancel" variant="outlined" color="primary" @click="handleCancelClick">キャンセル</a-button>
          </m-form-action-buttons>
          <template v-if="!readOnly">
            <div class="m-form-action-buttons">
              <div class="m-button-container m-button-container__delete">
                <a-button
                  id="delete"
                  :inline="true"
                  variant="block"
                  color="gray"
                  size="middle"
                  style="margin: 24px 0 0"
                  :disabled="!flagAllButtonEnable"
                  @click="handleDialogCompanyRemove"
                  >　削除　</a-button
                >
              </div>
            </div>
          </template>
        </form>
      </m-action-card>
    </m-section>
  </div>
  <teleport to="body">
    <o-modal
      id="settingCompanyEdit_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="buttonResultOk"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="handleCloseModal(next)"
        />
      </template>
    </o-modal>
  </teleport>
  <teleport to="body">
    <o-modal
      id="settingCompanyEdit_deleteResultModal"
      v-model:visible="deleteResultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="buttonDeleteResultOk"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="handleDeleteCloseModal"
        />
      </template>
    </o-modal>
  </teleport>
  <teleport to="body">
    <o-modal
      v-if="removeCompanyDialogVisible"
      id="settingCompanyEdit_removeModal"
      v-model:visible="removeCompanyDialogVisible"
      class="o-modal-remove-user-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      @close="handleCancelRemoveCompany"
    >
      <template #title> 企業情報削除確認 </template>
      <a-text :center="true">
        <!-- eslint-disable -->
        <!-- <span v-html="removeCompanyConfirmationMessageText" /> -->
        <span v-html="removeCompanyConfirmationMessageText" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="infoDeleteYes"
          variant="block"
          color="primary"
          label="はい"
          size="small"
          @click="handleConfirmRemoveCompany"
        />
        <a-button
          id="infoDeleteNo"
          variant="outlined"
          color="primary"
          label="いいえ"
          size="small"
          @click="handleCancelRemoveCompany"
        />
      </template>
    </o-modal>
  </teleport>
  <teleport to="body">
    <o-modal
      id="settingCompanyEdit_removeUploadModal"
      v-model:visible="removeUploadDialogVisible"
      class="o-modal-remove-contact-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      @close="handleCancelRemoveUpload"
    >
      <template #title> アップロードファイル削除確認 </template>
      <a-text :center="true">
        <!-- eslint-disable -->
        <span v-html="removeContactConfirmationMessageText" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="deleteFileYes"
          variant="block"
          color="primary"
          label="はい"
          size="small"
          @click="handleConfirmRemoveUpload"
        />
        <a-button
          id="deleteFileNo"
          variant="outlined"
          color="primary"
          label="いいえ"
          size="small"
          @click="handleCancelRemoveUpload"
        />
      </template>
    </o-modal>
  </teleport>
  <!--解約ダイアログ-->
  <teleport to="body">
    <o-modal
      id="settingCompanyEdit_cancelModal"
      v-model:visible="cancelContractCompanyDialogVisible"
      class="o-modal-remove-contact-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      @close="handleCancelCancelContractCompany"
    >
      <template #title> 解約確認 </template>
      <a-text :center="true">
        <!-- eslint-disable -->
        <span v-html="cancelContractCompanyConfirmationMessageText" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="buttonCancelYes"
          variant="block"
          color="primary"
          label="はい"
          size="small"
          @click="handleCompanyEdit"
        />
        <a-button
          id="buttonCancelNo"
          variant="outlined"
          color="primary"
          label="いいえ"
          size="small"
          @click="handleCancelCancelContractCompany"
        />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import MFormInput from '@/components/molecules/form-input';
import ATextField from '@/components/atoms/text-field';
// import ACaptionList from '@/components/atoms/caption-list';
import ASelectField from '@/components/atoms/select-field';
import { cloneDeep } from 'lodash';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import { POINT } from '@/libs/constants';
import { PREFECTURES } from '@/libs/constants';
import { JOBS } from '@/libs/constants';

export default {
  name: 't-setting-companys-edit',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    MFormInput,
    ATextField,
    // ACaptionList,
    ASelectField,
  },
  mixins: [customRequest, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
    authInfo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      companyInfoData: {
        companyID: '',
        companyName: '',
        customerID: '',
        companyKanaName: '',
        companyPostCode: '',
        companyAddress1: '',
        companyAddress2: '',
        companyAddress3: '',
        companyAddress4: '',
        companyBusinessDetails: '',
        companyNumber: '',
        companyRulerFlag: '',
        companyRulerName: '',
        companyRulerAddress: '',
        companyRulerBirthDate: '',
        companyRelationship: '',
        purposeOfUse: '',
        adminName: '',
        adminKanaName: '',
        adminPhoneNumber: '',
        adminEmail: '',
        adminBirthDate: '',
        adminJob: '',
        adminPostCode: '',
        adminAddress1: '',
        adminAddress2: '',
        adminAddress3: '',
        adminAddress4: '',
        invoicePostCode: '',
        invoiceAddress1: '',
        invoiceAddress2: '',
        invoiceAddress3: '',
        invoiceAddress4: '',
        invoiceName: '',
        invoiceKanaName: '',
        invoiceDepartment: '',
        invoicePhoneNumber: '',
        businessType: '',
        billType: '',
        voicedxOnlyFlag: '',
        openDay: '',
        contractStatus: '',
        soStatus: '',
        responderName: '',
        note: '',
        companyRulerName2: '',
        companyRulerAddress2: '',
        companyRulerBirthDate2: '',
        companyRelationship2: '',
        companyRulerName3: '',
        companyRulerAddress3: '',
        companyRulerBirthDate3: '',
        companyRelationship3: '',
        companyRulerName4: '',
        companyRulerAddress4: '',
        companyRulerBirthDate4: '',
        companyRelationship4: '',
        salesPerson: '',
        salesPersonKanaName: '',
        salesPersonEmailAddress: '',
        salesPersonPhoneNumber: '',
        salesPersonDepartment: '',
        expectedNumberOfPhoneNumber: '',
        expectedMaxNumberOfPhoneNumber: '',
        expectedMaxNumberOfOutgoingCalls: '',
        expectedMaxNumberOfIncomingCalls: '',
        signupResponderName: '',
        signupResponderNameKana: '',
        signupResponderMail: '',
        signupResponderPhoneNumber: '',
        signupResponderDepartment: '',
        inPersonTransactionFlag: '',
        inPersonCertificateType: '',
        documentCheckDay: '',
        documentType: '',
      },
      trialCompanyID: '',
      companyInfo: {},
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      flag: true,
      radio: 'false',
      historyList: [],
      certificateList: [],
      certificateInfo: {
        DriverlicenseURL1: '',
        DriverlicenseURL2: '',
        MyNumberURL: '',
        DrivingHistoryURL1: '',
        DrivingHistoryURL2: '',
        SealRegistrationURL: '',
        FamilyRegisterURL: '',
        CertificateOfResidenceURL: '',
        copyOfCompanyRegisterURL1: '',
        copyOfCompanyRegisterURL2: '',
        copyOfCompanyRegisterURL3: '',
        copyOfCompanyRegisterURL4: '',
        copyOfCompanyRegisterURL5: '',
        copyOfCompanyRegisterURL6: '',
        copyOfCompanyRegisterURL7: '',
        copyOfCompanyRegisterURL8: '',
        copyOfCompanyRegisterURL9: '',
        copyOfCompanyRegisterURL10: '',
        letterOfAttorneyURL: '',
      },
      formData: {
        documents: [{}],
      },
      businessTypeList: [
        {
          value: '',
          label: '選択してください',
        },
        {
          value: 'individual',
          label: '個人',
        },
        {
          value: 'company',
          label: '法人',
        },
      ],
      voicedxOnlyFlagList: [
        {
          value: 'true',
          label: 'COTOHA Voice DX Basicのみ',
        },
        {
          value: 'false',
          label: 'COTOHA Voice DX Basic・COTOHA Call Center共用',
        },
      ],
      inPersonTransactionFlagList: [
        { label: '選択してください', value: '' },
        { label: '対面取引', value: 'true' },
        { label: '非対面取引', value: 'false' },
      ],
      documentTypeList: [
        { label: '運転免許証', value: 'driverLicense' },
        { label: 'マイナンバーカード', value: 'myNumberCard' },
      ],
      inPersonCertificateTypeList: [
        {
          label: 'NTTコム営業担当者が「ビデオや電話会議または対面での会議」での協議にて、口頭で確認済み',
          value: 'salesPersonCheck',
        },
        { label: 'NTTコム営業担当者が委任状を目視にて確認済み', value: 'letterOfCommission' },
        { label: 'NTTコム営業担当者に委任状の写しをメールで提出', value: 'letterOfCommissionCopy' },
      ],
      contractStatusList: [
        {
          value: '',
          label: '選択してください',
        },
        {
          value: 'use',
          label: '利用中',
        },
        {
          value: 'close',
          label: '解約',
        },
      ],
      soStatusList: [
        {
          value: '',
          label: '選択してください',
        },
        {
          value: 'review',
          label: '審査中',
        },
        {
          value: 'pass',
          label: '合格',
        },
        {
          value: 'fail',
          label: '審査不合格',
        },
      ],
      removeCompanyConfirmationMessage: `{{ companyID }} を削除しますか？<br />`,
      removeCompanyDialogVisible: false,
      deleteResultModalVisible: false,
      reasonList: [],
      cancelReasonFlag: false,
      removeUploadDialogVisible: false,
      removeContactConfirmationMessageText: '',
      stay: false,
      flagAllButtonEnable: true, //#1892

      //解約ダイアログ
      cancelContractCompanyDialogVisible: false,
      cancelContractCompanyConfirmationMessageText: 'こちらの契約IDを解約してもよろしいですか？<br />',
      // #2456
      spCharCheckListEveryTime: [
        {
          name: '顧客ID',
          fieldName: 'customerID',
        },
        {
          name: '取引種別',
          fieldName: 'inPersonTransactionFlag',
        },
      ],
      spCharCheckListCompany: [
        {
          name: '契約名義',
          fieldName: 'companyName',
        },
        {
          name: '契約名義カナ',
          fieldName: 'companyKanaName',
        },
        {
          name: '郵便番号',
          fieldName: 'companyPostCode',
        },
        {
          name: '都道府県名',
          fieldName: 'companyAddress1',
        },
        {
          name: '市区町村',
          fieldName: 'companyAddress2',
        },
        {
          name: '字丁目番地など',
          fieldName: 'companyAddress3',
        },
        {
          name: '住所建物など',
          fieldName: 'companyAddress4',
        },
        {
          name: '事業内容',
          fieldName: 'companyBusinessDetails',
        },
        {
          name: '法人情報.法人番号',
          fieldName: 'companyNumber',
        },
      ],
      spCharCheckListRuler: [
        {
          name: '実質的支配者名',
          fieldName: 'companyRulerName',
        },
        {
          name: '実質的支配者住所',
          fieldName: 'companyRulerAddress',
        },
        {
          name: '実質的支配者生年月日',
          fieldName: 'companyRulerBirthDate',
        },
        {
          name: '実質的支配者の法人との関係',
          fieldName: 'companyRelationship',
        },
        {
          name: '実質的支配者名2',
          fieldName: 'companyRulerName2',
        },
        {
          name: '実質的支配者住所2',
          fieldName: 'companyRulerAddress2',
        },
        {
          name: '実質的支配者生年月日2',
          fieldName: 'companyRulerBirthDate2',
        },
        {
          name: '実質的支配者の法人との関係2',
          fieldName: 'companyRelationship2',
        },
        {
          name: '実質的支配者名3',
          fieldName: 'companyRulerName3',
        },
        {
          name: '実質的支配者住所3',
          fieldName: 'companyRulerAddress3',
        },
        {
          name: '実質的支配者生年月日3',
          fieldName: 'companyRulerBirthDate3',
        },
        {
          name: '実質的支配者の法人との関係3',
          fieldName: 'companyRelationship3',
        },
        {
          name: '実質的支配者名4',
          fieldName: 'companyRulerName4',
        },
        {
          name: '実質的支配者住所4',
          fieldName: 'companyRulerAddress4',
        },
        {
          name: '実質的支配者生年月日4',
          fieldName: 'companyRulerBirthDate4',
        },
        {
          name: '実質的支配者の法人との関係4',
          fieldName: 'companyRelationship4',
        },
      ],
      spCharCheckList: [
        {
          name: 'マスタ管理者.氏名',
          fieldName: 'adminLastName',
        },
        {
          name: 'マスタ管理者.氏名',
          fieldName: 'adminName',
        },
        {
          name: 'マスタ管理者.氏名カナ',
          fieldName: 'adminLastKanaName',
        },
        {
          name: 'マスタ管理者.氏名カナ',
          fieldName: 'adminKanaName',
        },
        {
          name: 'マスタ管理者.生年月日',
          fieldName: 'adminBirthDate',
        },
        {
          name: 'マスタ管理者.メールアドレス',
          fieldName: 'adminEmail',
        },
        {
          name: 'マスタ管理者.職業',
          fieldName: 'adminJob',
        },
        {
          name: 'マスタ管理者.電話番号',
          fieldName: 'adminPhoneNumber',
        },
        {
          name: 'マスタ管理者.郵便番号',
          fieldName: 'adminPostCode',
        },
        {
          name: 'マスタ管理者.都道府県名',
          fieldName: 'adminAddress1',
        },
        {
          name: 'マスタ管理者.市区町村',
          fieldName: 'adminAddress2',
        },
        {
          name: 'マスタ管理者.字丁目番地など',
          fieldName: 'adminAddress3',
        },
        {
          name: 'マスタ管理者.住所建物など',
          fieldName: 'adminAddress4',
        },
      ],
      spCharCheckListSalesPerson: [
        { name: '営業担当者情報.販売チャネルコード', fieldName: 'salesChannelCode' },
        { name: '営業担当者情報.販売担当者コード', fieldName: 'salesPersonCode' },
        { name: '営業担当者情報.販売担当者氏名（姓名）', fieldName: 'salesPerson' },
        { name: '営業担当者情報.販売担当者氏名カナ（姓名）', fieldName: 'salesPersonKanaName' },
        { name: '営業担当者情報.販売担当者組織/部課名', fieldName: 'salesPersonDepartment' },
        { name: '営業担当者情報.販売担当者メールアドレス', fieldName: 'salesPersonEmailAddress' },
        { name: '営業担当者情報.販売担当者電話番号', fieldName: 'salesPersonPhoneNumber' },
      ],
      spCharCheckListSignupResponder: [
        { name: 'お申し込み対応部門.お申し込み受付担当者 氏名（姓名）', fieldName: 'signupResponderName' },
        { name: 'お申し込み対応部門.お申し込み受付担当者 氏名カナ（姓名）', fieldName: 'signupResponderNameKana' },
        { name: 'お申し込み対応部門.お申し込み受付担当者 組織/部課名', fieldName: 'signupResponderDepartment' },
        { name: 'お申し込み対応部門.お申し込み受付担当者 メールアドレス', fieldName: 'signupResponderMail' },
        { name: 'お申し込み対応部門.お申し込み受付担当者 電話番号', fieldName: 'signupResponderPhoneNumber' },
      ],
      spCharCheckListHearing: [
        { name: 'ヒアリング事項.取引目的', fieldName: 'purposeOfUse' },
        {
          name: 'ヒアリング事項.利用予定の電話番号数（ご利用開始から1ヶ月間）',
          fieldName: 'expectedNumberOfPhoneNumber',
        },
        {
          name: 'ヒアリング事項.利用予定の電話番号数の最大値',
          fieldName: 'expectedMaxNumberOfPhoneNumber',
        },
        {
          name: 'ヒアリング事項.利用予定の電話発信回数（1ヶ月あたり）の最大値',
          fieldName: 'expectedMaxNumberOfOutgoingCalls',
        },
        {
          name: 'ヒアリング事項.利用予定の電話着信回数（1ヶ月あたり）の最大値',
          fieldName: 'expectedMaxNumberOfIncomingCalls',
        },
        { name: 'ヒアリング事項.取引時確認書類の確認日時', fieldName: 'documentCheckDay' },
        { name: 'ヒアリング事項.「契約に関する責任者連絡先」欄の確認を行った書類', fieldName: 'documentType' },
        { name: 'ヒアリング事項.取引の任に当たっていることを確認した方法', fieldName: 'inPersonCertificateType' },
      ],
      spCharCheckAddressInvoice: [
        {
          name: '請求書送付先①',
          fieldName: 'invoiceCompany',
        },
        {
          name: '請求書送付先②',
          fieldName: 'invoiceDepartment',
        },
      ],
      spCharCheckListInvoice: [
        {
          name: '請求書送付先.郵便番号',
          fieldName: 'invoicePostCode',
        },
        {
          name: '請求書送付先.都道府県名',
          fieldName: 'invoiceAddress1',
        },
        {
          name: '請求書送付先.市区町村',
          fieldName: 'invoiceAddress2',
        },
        {
          name: '請求書送付先.字丁目番地など',
          fieldName: 'invoiceAddress3',
        },
        {
          name: '請求書送付先.住所建物など',
          fieldName: 'invoiceAddress4',
        },
        {
          name: '請求書送付先.送付先名',
          fieldName: 'invoiceName',
        },
        {
          name: '請求書送付先.送付先名カナ',
          fieldName: 'invoiceKanaName',
        },
        {
          name: '請求書送付先.電話番号',
          fieldName: 'invoicePhoneNumber',
        },
      ],
      spCharCheckListOther: [
        {
          name: 'その他.支払い方法',
          fieldName: 'billType',
        },
        {
          name: 'その他.開通希望日',
          fieldName: 'openDay',
        },
        {
          name: 'その他.解約日',
          fieldName: 'closeDate',
        },
        {
          name: 'その他.備考',
          fieldName: 'note',
        },
        {
          name: 'その他.応対者',
          fieldName: 'responderName',
        },
      ],
      readOnly: false,
      previousContractStatus: '',
      prefectures: [],
      jobs: [],
      invoiceNameData: {
        invoiceCompany: '',
        invoiceDepartment: '',
        invoiceNameView: '',
      },
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-companys-edit');
      return `${baseClassName} ${this.class}`.trim();
    },
    removeCompanyConfirmationMessageText() {
      if (this.$route.query.companyID) {
        return this.convertMessage(this.removeCompanyConfirmationMessage, this.$route.query.companyID);
      } else {
        return this.removeCompanyConfirmationMessage;
      }
    },
  },
  async mounted() {
    if (this.companyID !== POINT) {
      this.$router.push({ path: '/permission-denied' });
    }

    this.flagAllButtonEnable = true; //#1892
    this.prefectures = PREFECTURES;
    this.jobs = JOBS;

    await this.fetchCancelReasonDataHandler();

    const companyID = this.$route.query.companyID;

    if (this.authInfo === 'operator' || (companyID === POINT && this.authInfo === 'soOperator')) {
      this.readOnly = true;
    }

    if (companyID.indexOf('tri') !== -1) {
      this.readOnly = true;
    }

    if (companyID) {
      this.postRequest('/companymgmt/search', { companyID: companyID })
        .then(e => {
          if (e.status === 'success') {
            e.data.billType = '請求書払い';

            e.data.voicedxOnlyFlagView = 'true';
            if (e.data.voicedxOnlyFlag !== true) {
              e.data.voicedxOnlyFlag = false;
              e.data.voicedxOnlyFlagView = 'false';
            }

            this.companyInfoData = e.data;
            let arrAdminName = this.companyInfoData.adminName.split('_');
            if (!arrAdminName[1]) {
              arrAdminName = this.companyInfoData.adminName.split(' ');
            }
            this.companyInfoData.adminLastName = arrAdminName[0];
            this.companyInfoData.adminName = arrAdminName[1];
            let arrAdminKanaName = this.companyInfoData.adminKanaName.split('_');
            if (!arrAdminKanaName[1]) {
              arrAdminKanaName = this.companyInfoData.adminKanaName.split(' ');
            }
            this.companyInfoData.adminLastKanaName = arrAdminKanaName[0];
            this.companyInfoData.adminKanaName = arrAdminKanaName[1];

            if (this.companyInfoData.companyRulerFlag === true) {
              this.radio = 'true';
            } else {
              this.radio = 'false';
            }

            let companyRulerNo = '';
            const arrInput = [
              'companyRulerName',
              'companyRulerAddress',
              'companyRulerBirthDate',
              'companyRelationship',
            ];
            for (let i = 0; i < 4; i++) {
              if (i > 0) {
                companyRulerNo = String(i + 1);
              }

              for (let j = 0; j < arrInput.length; j++) {
                if (typeof e.data[arrInput[j] + companyRulerNo] === 'undefined') {
                  this.companyInfoData[arrInput[j] + companyRulerNo] = '';
                }
              }
              this.companyInfoData['companyRulerBirthDate' + companyRulerNo] = this.companyInfoData[
                'companyRulerBirthDate' + companyRulerNo
              ].replace(/-/g, '');
            }

            this.companyInfoData.adminBirthDate = this.companyInfoData.adminBirthDate.replace(/-/g, '');
            this.companyInfoData.companyRulerBirthDate = this.companyInfoData.companyRulerBirthDate.replace(/-/g, '');
            this.companyInfoData.openDay = this.companyInfoData.openDay.replace(/-/g, '');

            if (this.companyInfoData.voicedxOnlyFlag) {
              this.companyInfoData.voicedxOnlyFlagView = 'COTOHA Voice DX Basicのみ';
            } else {
              this.companyInfoData.voicedxOnlyFlagView = 'COTOHA Voice DX Basic・COTOHA Call Center共用';
            }

            // soStatus
            if (this.companyInfoData.soStatus === 'review') {
              this.companyInfoData.soStatusView = '審査中';
            } else if (this.companyInfoData.soStatus === 'pass') {
              this.companyInfoData.soStatusView = '合格';
            } else if (this.companyInfoData.soStatus === 'fail') {
              this.companyInfoData.soStatusView = '審査不合格';
            }

            // 解約理由
            this.cancelReasonFlag = false;
            if (this.companyInfoData.contractStatus === 'close') {
              this.cancelReasonFlag = true;
              for (let i = 0; i < this.reasonList.length; i++) {
                if (this.reasonList[i].value === '0') {
                  this.reasonList[i].label = 'その他:' + this.companyInfoData.cancelReason;
                }
              }
            }

            // format startDate・closeDate
            if (this.companyInfoData.startDate) {
              this.companyInfoData.startDate = this.companyInfoData.startDate.replaceAll('-', '');
            }
            if (this.companyInfoData.closeDate) {
              this.companyInfoData.closeDate = this.companyInfoData.closeDate.replaceAll('-', '');
            }

            // 都道府県名プルダウン値の処理
            let address1Msg = '';
            let found = this.prefectures.find(element => element.value === this.companyInfoData.adminAddress1);
            if (typeof found === 'undefined') {
              address1Msg = messageContent.alertNotCorrectFormat('マスタ管理者:都道府県名') + '<br>';
              this.companyInfoData.adminAddress1 = '';
            }

            found = this.prefectures.find(element => element.value === this.companyInfoData.invoiceAddress1);
            if (typeof found === 'undefined') {
              address1Msg += messageContent.alertNotCorrectFormat('請求書送付先:都道府県名') + '<br>';
              this.companyInfoData.invoiceAddress1 = '';
            }

            found = this.prefectures.find(element => element.value === this.companyInfoData.companyAddress1);
            if (typeof found === 'undefined') {
              address1Msg += messageContent.alertNotCorrectFormat('法人情報:都道府県名');
              this.companyInfoData.companyAddress1 = '';
            }

            if (address1Msg !== '') {
              this.showErrorModal(address1Msg);
            }

            // 職業を変換して値セット
            found = this.jobs.find(element => element.value === this.companyInfoData.adminJob);
            if (typeof found !== 'undefined') {
              this.companyInfoData.adminJob = found.label;
            }

            // 対面フラグをstring化
            if (typeof this.companyInfoData.inPersonTransactionFlag === 'boolean') {
              this.companyInfoData.inPersonTransactionFlag = this.companyInfoData.inPersonTransactionFlag.toString();
            } else {
              this.companyInfoData.inPersonTransactionFlag = '';
            }

            this.sethistoryList();

            // #3331 ステータス初期値を保存しておく
            this.previousContractStatus = this.companyInfoData.contractStatus;

            this.invoiceNameData.invoiceNameView = this.companyInfoData.invoiceName;
          }
        })
        .catch(error => {
          console.log(error);
          this.showErrorModal(messageContent.requireTry('検索'));
        });
      this.postRequest('/companymgmt/searchMigrationSource', { companyID: companyID })
        .then(e => {
          if (e.status === 'success' && typeof e.data !== 'undefined') {
            this.trialCompanyID = e.data.companyID;
          }
        })
        .catch(error => {
          console.log(error);
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    }
  },
  methods: {
    handleFormSubmit(event) {
      event.preventDefault();
      this.handleDialogCompanyUpdate(cloneDeep(this.companyInfoData));
    },
    checkInputParameter() {
      // 特殊記号のチェック：基本項目
      for (const item of this.spCharCheckListEveryTime) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName] })) {
          return item.name + 'に' + messageContent.hasSpecialCharacter;
        }
      }
      if (this.companyInfoData.businessType === 'company') {
        // 特殊記号のチェック：法人情報
        for (const item of this.spCharCheckListCompany) {
          if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName] })) {
            return item.name + 'に' + messageContent.hasSpecialCharacter;
          }
        }
        // 特殊記号のチェック：実質的支配者の情報
        if (this.companyInfoData.companyRulerFlag === true) {
          for (const item of this.spCharCheckListRuler) {
            if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName] })) {
              return item.name + 'に' + messageContent.hasSpecialCharacter;
            }
          }
        }
      }
      // 特殊記号のチェック：マスタ管理者
      for (const item of this.spCharCheckList) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName].replace(/\r?\n/g, '') })) {
          return item.name + 'に' + messageContent.hasSpecialCharacter;
        }
      }
      // 特殊記号のチェック：営業担当者情報
      for (const item of this.spCharCheckListSalesPerson) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName] })) {
          return item.name + 'に' + messageContent.hasSpecialCharacter;
        }
      }
      // 特殊記号のチェック：お申し込み対応部門
      for (const item of this.spCharCheckListSignupResponder) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName] })) {
          return item.name + 'に' + messageContent.hasSpecialCharacter;
        }
      }
      // 特殊記号のチェック：ヒアリング事項
      for (const item of this.spCharCheckListHearing) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName] })) {
          return item.name + 'に' + messageContent.hasSpecialCharacter;
        }
      }
      // 特殊記号のチェック：請求書情報
      for (const item of this.spCharCheckListInvoice) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName] })) {
          return item.name + 'に' + messageContent.hasSpecialCharacter;
        }
      }
      // 特殊記号のチェック：その他
      for (const item of this.spCharCheckListOther) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName].replace(/\r?\n/g, '') })) {
          return item.name + 'に' + messageContent.hasSpecialCharacter;
        }
      }
      // 特殊記号のチェック：請求書送付先①②
      for (const item of this.spCharCheckAddressInvoice) {
        if (
          this.hasSpecialCharacterInObjectInvoice({
            keyWord: this.invoiceNameData[item.fieldName].replace(/\r?\n/g, ''),
          })
        ) {
          return item.name + 'に' + messageContent.hasSpecialCharacterInvoiceName;
        }
      }

      return null;
    },
    generateSendData() {
      const adminBirthDate = this.companyInfoData.adminBirthDate;
      let y = adminBirthDate.substr(0, 4);
      let m = adminBirthDate.substr(4, 2);
      let d = adminBirthDate.substr(6);
      const value = y + '-' + m + '-' + d;

      let companyRulerNo = '';
      const setCompanyInfoData = [];
      for (let i = 0; i < 4; i++) {
        if (i > 0) {
          companyRulerNo = String(i + 1);
        }

        const companyRulerBirthDate = this.companyInfoData['companyRulerBirthDate' + companyRulerNo];
        if (companyRulerBirthDate !== '' && typeof companyRulerBirthDate !== 'undefined') {
          const y = companyRulerBirthDate.substr(0, 4);
          const m = companyRulerBirthDate.substr(4, 2);
          const d = companyRulerBirthDate.substr(6);
          setCompanyInfoData[i + 1] = y + '-' + m + '-' + d;
        } else {
          setCompanyInfoData[i + 1] = '';
        }
      }

      // 開通希望日の更新(voicedxOnlyFlagがfalseの際にopenDayを空にする処理を含む)
      let value3 = '';
      if (this.companyInfoData.voicedxOnlyFlag === true) {
        const openDay = this.companyInfoData.openDay;
        if (openDay !== '') {
          y = openDay.substr(0, 4);
          m = openDay.substr(4, 2);
          d = openDay.substr(6);
          value3 = y + '-' + m + '-' + d;
        }
        //CCC/VDXB共用の場合、ステータス変更及び解約日入力で解約処理がはしらない
      } else if (
        !this.companyInfoData.voicedxOnlyFlag &&
        (this.companyInfoData.contractStatus === 'close' || this.companyInfoData.closeDate) &&
        this.previousContractStatus !== 'close'
      ) {
        return this.showErrorModal(`CCC/VDXB共用は解約できません。`);
      }

      // closeDate
      let closeDate = this.companyInfoData.closeDate;

      if (closeDate !== '') {
        y = this.companyInfoData.closeDate.substr(0, 4);
        m = this.companyInfoData.closeDate.substr(4, 2);
        d = this.companyInfoData.closeDate.substr(6);
        closeDate = y + '-' + m + '-' + d;
      }

      // 職業を変換して値セット
      const found = this.jobs.find(element => element.label === this.companyInfoData.adminJob);
      if (typeof found !== 'undefined') {
        this.companyInfoData.adminJob = found.value;
      }

      // 対面フラグをboolean化
      let inPersonTransactionFlag;
      switch (this.companyInfoData.inPersonTransactionFlag) {
        case 'true':
          inPersonTransactionFlag = true;
          break;
        case 'false':
          inPersonTransactionFlag = false;
          break;
        default:
          inPersonTransactionFlag = undefined;
      }

      const sendData = {
        companyID: this.companyInfoData.companyID,
        companyName: this.companyInfoData.companyName ? this.companyInfoData.companyName : '',
        customerID: this.companyInfoData.customerID ? this.companyInfoData.customerID : '',
        companyKanaName: this.companyInfoData.companyKanaName ? this.companyInfoData.companyKanaName : '',
        companyPostCode: this.companyInfoData.companyPostCode ? this.companyInfoData.companyPostCode : '',
        companyAddress1: this.companyInfoData.companyAddress1 ? this.companyInfoData.companyAddress1 : '',
        companyAddress2: this.companyInfoData.companyAddress2 ? this.companyInfoData.companyAddress2 : '',
        companyAddress3: this.companyInfoData.companyAddress3 ? this.companyInfoData.companyAddress3 : '',
        companyAddress4: this.companyInfoData.companyAddress4 ? this.companyInfoData.companyAddress4 : '',
        companyBusinessDetails: this.companyInfoData.companyBusinessDetails
          ? this.companyInfoData.companyBusinessDetails
          : '',
        companyNumber: this.companyInfoData.companyNumber ? this.companyInfoData.companyNumber : '',
        companyRulerFlag: this.radio === 'false' ? false : true,
        companyRulerName: this.companyInfoData.companyRulerName ? this.companyInfoData.companyRulerName : '',
        companyRulerAddress: this.companyInfoData.companyRulerAddress ? this.companyInfoData.companyRulerAddress : '',
        companyRulerBirthDate: setCompanyInfoData[1],
        companyRelationship: this.companyInfoData.companyRelationship ? this.companyInfoData.companyRelationship : '',
        companyRulerName2: this.companyInfoData.companyRulerName2 ? this.companyInfoData.companyRulerName2 : '',
        companyRulerAddress2: this.companyInfoData.companyRulerAddress2
          ? this.companyInfoData.companyRulerAddress2
          : '',
        companyRulerBirthDate2: setCompanyInfoData[2],
        companyRelationship2: this.companyInfoData.companyRelationship2
          ? this.companyInfoData.companyRelationship2
          : '',
        companyRulerName3: this.companyInfoData.companyRulerName3 ? this.companyInfoData.companyRulerName3 : '',
        companyRulerAddress3: this.companyInfoData.companyRulerAddress3
          ? this.companyInfoData.companyRulerAddress3
          : '',
        companyRulerBirthDate3: setCompanyInfoData[3],
        companyRelationship3: this.companyInfoData.companyRelationship3
          ? this.companyInfoData.companyRelationship3
          : '',
        companyRulerName4: this.companyInfoData.companyRulerName4 ? this.companyInfoData.companyRulerName4 : '',
        companyRulerAddress4: this.companyInfoData.companyRulerAddress4
          ? this.companyInfoData.companyRulerAddress4
          : '',
        companyRulerBirthDate4: setCompanyInfoData[4],
        companyRelationship4: this.companyInfoData.companyRelationship4
          ? this.companyInfoData.companyRelationship4
          : '',
        purposeOfUse: this.companyInfoData.purposeOfUse
          ? this.companyInfoData.purposeOfUse.replace(/\n/g, '%%n%%')
          : '', // #2138
        adminLastName: this.companyInfoData.adminLastName ? this.companyInfoData.adminLastName : '',
        adminName: this.companyInfoData.adminName ? this.companyInfoData.adminName : '',
        adminLastKanaName: this.companyInfoData.adminLastKanaName ? this.companyInfoData.adminLastKanaName : '',
        adminKanaName: this.companyInfoData.adminKanaName ? this.companyInfoData.adminKanaName : '',
        adminPhoneNumber: this.companyInfoData.adminPhoneNumber ? this.companyInfoData.adminPhoneNumber : '',
        adminEmail: this.companyInfoData.adminEmail ? this.companyInfoData.adminEmail : '',
        adminBirthDate: value,
        adminJob: this.companyInfoData.adminJob ? this.companyInfoData.adminJob : '',
        adminPostCode: this.companyInfoData.adminPostCode ? this.companyInfoData.adminPostCode : '',
        adminAddress1: this.companyInfoData.adminAddress1 ? this.companyInfoData.adminAddress1 : '',
        adminAddress2: this.companyInfoData.adminAddress2 ? this.companyInfoData.adminAddress2 : '',
        adminAddress3: this.companyInfoData.adminAddress3 ? this.companyInfoData.adminAddress3 : '',
        adminAddress4: this.companyInfoData.adminAddress4 ? this.companyInfoData.adminAddress4 : '',
        invoicePostCode: this.companyInfoData.invoicePostCode ? this.companyInfoData.invoicePostCode : '',
        invoiceAddress1: this.companyInfoData.invoiceAddress1 ? this.companyInfoData.invoiceAddress1 : '',
        invoiceAddress2: this.companyInfoData.invoiceAddress2 ? this.companyInfoData.invoiceAddress2 : '',
        invoiceAddress3: this.companyInfoData.invoiceAddress3 ? this.companyInfoData.invoiceAddress3 : '',
        invoiceAddress4: this.companyInfoData.invoiceAddress4 ? this.companyInfoData.invoiceAddress4 : '',
        invoiceName: this.companyInfoData.invoiceName ? this.companyInfoData.invoiceName : '',
        invoiceKanaName: this.companyInfoData.invoiceKanaName ? this.companyInfoData.invoiceKanaName : '',
        // #4513 請求先電話番号が空欄のときはダミーデータをセットする
        invoicePhoneNumber: this.companyInfoData.invoicePhoneNumber
          ? this.companyInfoData.invoicePhoneNumber
          : '00000000000',
        invoiceDepartment: this.companyInfoData.invoiceDepartment ? this.companyInfoData.invoiceDepartment : '',
        businessType: this.companyInfoData.businessType ? this.companyInfoData.businessType : '',
        billType: this.companyInfoData.billType ? this.companyInfoData.billType : '',
        inPersonTransactionFlag: inPersonTransactionFlag,
        inPersonCertificateType: this.companyInfoData.inPersonCertificateType
          ? this.companyInfoData.inPersonCertificateType
          : '',
        documentCheckDay:
          this.companyInfoData.inPersonTransactionFlag && this.companyInfoData.documentCheckDay
            ? this.companyInfoData.documentCheckDay
            : '',
        documentType:
          this.companyInfoData.inPersonTransactionFlag && this.companyInfoData.documentType
            ? this.companyInfoData.documentType
            : '',
        voicedxOnlyFlag: this.companyInfoData.voicedxOnlyFlag ? true : false,
        openDay: value3,
        contractStatus: this.companyInfoData.contractStatus ? this.companyInfoData.contractStatus : '',
        soStatus: this.companyInfoData.soStatus ? this.companyInfoData.soStatus : '',
        responderName: this.companyInfoData.responderName ? this.companyInfoData.responderName : '',
        note: this.companyInfoData.note ? this.companyInfoData.note.replace(/\n/g, '%%n%%') : '', // #2138
        closeDate: closeDate,
        salesChannelCode: this.companyInfoData.salesChannelCode ? this.companyInfoData.salesChannelCode : '',
        salesPersonCode: this.companyInfoData.salesPersonCode ? this.companyInfoData.salesPersonCode : '',
        suspendedDate: !!this.companyInfoData.suspendedDate,
        salesPerson: this.companyInfoData.salesPerson ? this.companyInfoData.salesPerson : '',
        salesPersonKanaName: this.companyInfoData.salesPersonKanaName ? this.companyInfoData.salesPersonKanaName : '',
        salesPersonEmailAddress: this.companyInfoData.salesPersonEmailAddress
          ? this.companyInfoData.salesPersonEmailAddress
          : '',
        salesPersonPhoneNumber: this.companyInfoData.salesPersonPhoneNumber
          ? this.companyInfoData.salesPersonPhoneNumber
          : '',
        salesPersonDepartment: this.companyInfoData.salesPersonDepartment
          ? this.companyInfoData.salesPersonDepartment
          : '',
        expectedNumberOfPhoneNumber: this.companyInfoData.expectedNumberOfPhoneNumber
          ? this.companyInfoData.expectedNumberOfPhoneNumber
          : '',
        expectedMaxNumberOfPhoneNumber: this.companyInfoData.expectedMaxNumberOfPhoneNumber
          ? this.companyInfoData.expectedMaxNumberOfPhoneNumber
          : '',
        expectedMaxNumberOfOutgoingCalls: this.companyInfoData.expectedMaxNumberOfOutgoingCalls
          ? this.companyInfoData.expectedMaxNumberOfOutgoingCalls
          : '',
        expectedMaxNumberOfIncomingCalls: this.companyInfoData.expectedMaxNumberOfIncomingCalls
          ? this.companyInfoData.expectedMaxNumberOfIncomingCalls
          : '',
        previousContractStatus: this.previousContractStatus,
        signupResponderName: this.companyInfoData.signupResponderName ? this.companyInfoData.signupResponderName : '',
        signupResponderNameKana: this.companyInfoData.signupResponderNameKana
          ? this.companyInfoData.signupResponderNameKana
          : '',
        signupResponderMail: this.companyInfoData.signupResponderMail ? this.companyInfoData.signupResponderMail : '',
        signupResponderPhoneNumber: this.companyInfoData.signupResponderPhoneNumber
          ? this.companyInfoData.signupResponderPhoneNumber
          : '',
        signupResponderDepartment: this.companyInfoData.signupResponderDepartment
          ? this.companyInfoData.signupResponderDepartment
          : '',
      };
      return sendData;
    },
    handleCompanyEdit() {
      this.handleCancelCancelContractCompany();

      // 入力パラメータのチェック
      const resultParameterCheck = this.checkInputParameter();
      if (resultParameterCheck) {
        this.showErrorModal(resultParameterCheck);
        return '';
      }

      // 更新する企業情報の作成
      const sendData = this.generateSendData();

      // 企業情報更新
      return this.postRequest('/companymgmt/update', { data: sendData })
        .then(e => {
          if (e.status === 'success') {
            // #3331
            this.previousContractStatus = this.companyInfoData.contractStatus;
            this.showInfoModal(messageContent.companyInfoUpdated, '/companymgmt');
          } else {
            if (e.msg !== '') {
              this.showErrorModal(e.msg);
            } else {
              this.showErrorModal(messageContent.canNotUpdateCompanyInfo);
            }
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.canNotUpdateCompanyInfo);
        });
    },
    handleCancelClick() {
      this.$router.push('/companymgmt');
    },
    handleDialogCompanyRemove() {
      this.removeCompanyDialogVisible = true;
      this.flagAllButtonEnable = false; //#1892
    },
    handleDialogUploadRemove() {
      const self = this;
      const formDataTmp = {
        companyID: this.$route.query.companyID,
      };
      this.flagAllButtonEnable = false; //#1892
      this.postRequest('/contract/chkchangeapply', formDataTmp)
        .then(e => {
          if (e.status === 'success') {
            this.removeUploadDialogVisible = true;
            this.removeContactConfirmationMessageText = 'アップロードファイルを削除しますか？';
          } else {
            if (e.msg !== '') {
              self.showErrorModal(e.msg);
            } else {
              self.showErrorModal(messageContent.requireTry('変更申請の確認'));
            }
            this.flagAllButtonEnable = true; //#1892
          }
        })
        .catch(() => {
          self.showErrorModal(messageContent.requireTry('変更申請の確認'));
          this.flagAllButtonEnable = true; //#1892
        });
    },
    handleDialogCompanyUpdate() {
      // 請求書送付先②がある、請求書送付先①nullチェック
      if (this.invoiceNameData.invoiceDepartment && !this.invoiceNameData.invoiceCompany) {
        this.showErrorModal(messageContent.invoiceCompanyRequired);
        return;
      }
      //「請求書送付先①」と「請求書送付先②」から送付先名に変換する
      if (!this.invoiceNameData.invoiceDepartment && this.invoiceNameData.invoiceCompany) {
        this.companyInfoData.invoiceName = this.invoiceNameData.invoiceCompany;
      } else if (this.invoiceNameData.invoiceDepartment && this.invoiceNameData.invoiceCompany) {
        this.companyInfoData.invoiceName =
          this.invoiceNameData.invoiceCompany + '／' + this.invoiceNameData.invoiceDepartment;
      }

      if (this.companyInfoData.contractStatus === 'close' && this.previousContractStatus !== 'close') {
        this.cancelContractCompanyDialogVisible = true;
        this.flagAllButtonEnable = false;
      } else {
        this.handleCompanyEdit(cloneDeep(this.companyInfoData));
      }
    },
    handleUploadRemove() {
      const self = this;
      const formDataTmp = {
        companyID: this.$route.query.companyID,
      };
      this.postRequest('/contract/uploadremove', formDataTmp)
        .then(e => {
          if (e.status === 'success') {
            self.deleteResultModalVisible = true;
            this.resultModalTitle = messageContent.infoModalTitle;
            this.resultModalContent = `アップロードファイルを削除しました。`;

            for (let i = 0; i < this.certificateList.length; i++) {
              for (const key in this.certificateList[i]) {
                if (key !== 'value') {
                  this.certificateList[i][key] = '';
                  this.certificateInfo[key] = '';
                }
              }
            }

            this.stay = true;
          } else {
            if (e.msg !== '') {
              self.showErrorModal(e.msg);
            } else {
              self.showErrorModal(messageContent.requireTry('アップロードファイル削除'));
            }
          }
          this.flagAllButtonEnable = true; //#1892
        })
        .catch(() => {
          self.showErrorModal(messageContent.requireTry('アップロードファイル削除'));
          this.flagAllButtonEnable = true; //#1892
        });
    },
    handleCompanyRemove() {
      const self = this;
      const formDataTmp = {
        companyID: this.$route.query.companyID,
      };
      this.postRequest('/companymgmt/delete', formDataTmp)
        .then(e => {
          if (e.status === 'success') {
            self.deleteResultModalVisible = true;
            this.resultModalTitle = messageContent.infoModalTitle;
            this.resultModalContent = `企業情報${this.$route.query.companyID}を削除しました。`;
            this.stay = false;
          } else if (e.status === 'companyInUse') {
            self.showErrorModal(messageContent.canNotDeleteUncanceledContract);
          } else if (e.status === 'callerNumberExist') {
            self.showErrorModal(messageContent.notReleaseVDXAndCCCUnlessDeleteNumber());
          } else {
            self.showErrorModal(messageContent.requireTry('企業情報削除'));
          }
          this.flagAllButtonEnable = true; //#1892
        })
        .catch(() => {
          self.showErrorModal(messageContent.requireTry('企業情報削除'));
          this.flagAllButtonEnable = true; //#1892
        });
    },
    handleConfirmRemoveCompany() {
      this.removeCompanyDialogVisible = false;
      this.handleCompanyRemove();
    },
    handleCancelRemoveCompany() {
      this.removeCompanyDialogVisible = false;
      this.selectedCompanyID = '';
      this.flagAllButtonEnable = true; //#1892
    },
    handleCloseModal(next) {
      if (next) {
        this.$router.push(next);
      }
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    handleDeleteCloseModal() {
      this.deleteResultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
      if (!this.stay) {
        this.$router.push('/companymgmt');
      }
    },
    handleConfirmRemoveUpload() {
      this.removeUploadDialogVisible = false;
      this.handleUploadRemove();
    },
    handleCancelRemoveUpload() {
      this.removeUploadDialogVisible = false;
      this.flagAllButtonEnable = true; //#1892
    },
    handleCancelCancelContractCompany() {
      this.cancelContractCompanyDialogVisible = false;
      this.flagAllButtonEnable = true;
    },
    handlePasswordReset() {
      const formDataTmp = {
        userID: this.userData.userID,
        companyID: this.selectedCompanyID,
      };
      this.postRequest('/idmgmt/resetpassword', formDataTmp)
        .then(e => {
          if (e.status === 'success') {
            this.showInfoModal(messageContent.passwordEmailed);
          } else {
            this.showErrorModal(messageContent.canNotResetPassword);
          }
        })
        .catch(error => {
          this.showErrorModal(messageContent.canNotResetPassword);
        });
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message, next = '') {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
      this.next = next;
    },
    sethistoryList() {
      this.historyList.push({
        value: '',
        label: '選択してください',
        companyID: this.companyInfoData.companyID,
        companyName: this.companyInfoData.companyName,
        customerID: this.companyInfoData.customerID,
        companyKanaName: this.companyInfoData.companyKanaName,
        companyPostCode: this.companyInfoData.companyPostCode,
        companyAddress1: this.companyInfoData.companyAddress1,
        companyAddress2: this.companyInfoData.companyAddress2,
        companyAddress3: this.companyInfoData.companyAddress3,
        companyAddress4: this.companyInfoData.companyAddress4,
        companyBusinessDetails: this.companyInfoData.companyBusinessDetails,
        companyNumber: this.companyInfoData.companyNumber,
        companyRulerFlag: this.companyInfoData.companyRulerFlag,
        companyRulerName: this.companyInfoData.companyRulerName,
        companyRulerAddress: this.companyInfoData.companyRulerAddress,
        companyRulerBirthDate: this.companyInfoData.companyRulerBirthDate,
        companyRelationship: this.companyInfoData.companyRelationship,
        companyRulerName2: this.companyInfoData.companyRulerName2,
        companyRulerAddress2: this.companyInfoData.companyRulerAddress2,
        companyRulerBirthDate2: this.companyInfoData.companyRulerBirthDate2,
        companyRelationship2: this.companyInfoData.companyRelationship2,
        companyRulerName3: this.companyInfoData.companyRulerName3,
        companyRulerAddress3: this.companyInfoData.companyRulerAddress3,
        companyRulerBirthDate3: this.companyInfoData.companyRulerBirthDate3,
        companyRelationship3: this.companyInfoData.companyRelationship3,
        companyRulerName4: this.companyInfoData.companyRulerName4,
        companyRulerAddress4: this.companyInfoData.companyRulerAddress4,
        companyRulerBirthDate4: this.companyInfoData.companyRulerBirthDate4,
        companyRelationship4: this.companyInfoData.companyRelationship4,
        purposeOfUse: this.companyInfoData.purposeOfUse,
        adminLastName: this.companyInfoData.adminLastName,
        adminName: this.companyInfoData.adminName,
        adminLastKanaName: this.companyInfoData.adminLastKanaName,
        adminKanaName: this.companyInfoData.adminKanaName,
        adminPhoneNumber: this.companyInfoData.adminPhoneNumber,
        adminEmail: this.companyInfoData.adminEmail,
        adminBirthDate: this.companyInfoData.adminBirthDate,
        adminJob: this.companyInfoData.adminJob,
        adminPostCode: this.companyInfoData.adminPostCode,
        adminAddress1: this.companyInfoData.adminAddress1,
        adminAddress2: this.companyInfoData.adminAddress2,
        adminAddress3: this.companyInfoData.adminAddress3,
        adminAddress4: this.companyInfoData.adminAddress4,
        invoicePostCode: this.companyInfoData.invoicePostCode,
        invoiceAddress1: this.companyInfoData.invoiceAddress1,
        invoiceAddress2: this.companyInfoData.invoiceAddress2,
        invoiceAddress3: this.companyInfoData.invoiceAddress3,
        invoiceAddress4: this.companyInfoData.invoiceAddress4,
        invoiceName: this.companyInfoData.invoiceName,
        invoiceKanaName: this.companyInfoData.invoiceKanaName,
        invoicePhoneNumber: this.companyInfoData.invoicePhoneNumber,
        invoiceDepartment: this.companyInfoData.invoiceDepartment,
        note: this.companyInfoData.note,
        businessType: this.companyInfoData.businessType,
        billType: this.companyInfoData.billType,
        inPersonTransactionFlag: this.companyInfoData.inPersonTransactionFlag,
        inPersonCertificateType: this.companyInfoData.inPersonCertificateType,
        documentCheckDay: this.companyInfoData.documentCheckDay,
        documentType: this.companyInfoData.documentType,
        voicedxOnlyFlag: this.companyInfoData.voicedxOnlyFlag,
        voicedxOnlyFlagView: this.companyInfoData.voicedxOnlyFlagView,
        openDay: this.companyInfoData.openDay,
        contractStatus: this.companyInfoData.contractStatus,
        soStatus: this.companyInfoData.soStatus,
        responderName: this.companyInfoData.responderName,
        cancelNumber: this.companyInfoData.cancelNumber,
        cancelReason: this.companyInfoData.cancelReason,
        startDate: this.companyInfoData.startDate,
        closeDate: this.companyInfoData.closeDate,
        salesChannelCode: this.companyInfoData.salesChannelCode,
        salesPersonCode: this.companyInfoData.salesPersonCode,
        salesPerson: this.companyInfoData.salesPerson,
        salesPersonKanaName: this.companyInfoData.salesPersonKanaName,
        salesPersonEmailAddress: this.companyInfoData.salesPersonEmailAddress,
        salesPersonPhoneNumber: this.companyInfoData.salesPersonPhoneNumber,
        salesPersonDepartment: this.companyInfoData.salesPersonDepartment,
        expectedNumberOfPhoneNumber: this.companyInfoData.expectedNumberOfPhoneNumber,
        expectedMaxNumberOfPhoneNumber: this.companyInfoData.expectedMaxNumberOfPhoneNumber,
        expectedMaxNumberOfOutgoingCalls: this.companyInfoData.expectedMaxNumberOfOutgoingCalls,
        expectedMaxNumberOfIncomingCalls: this.companyInfoData.expectedMaxNumberOfIncomingCalls,
        signupResponderName: this.companyInfoData.signupResponderName,
        signupResponderNameKana: this.companyInfoData.signupResponderNameKana,
        signupResponderMail: this.companyInfoData.signupResponderMail,
        signupResponderPhoneNumber: this.companyInfoData.signupResponderPhoneNumber,
        signupResponderDepartment: this.companyInfoData.signupResponderDepartment,
      });

      this.certificateList.push({
        value: '',
        DriverlicenseURL1: '',
        DriverlicenseURL2: '',
        MyNumberURL: '',
        DrivingHistoryURL1: '',
        DrivingHistoryURL2: '',
        SealRegistrationURL: '',
        FamilyRegisterURL: '',
        CertificateOfResidenceURL: '',
        copyOfCompanyRegisterURL1: '',
        copyOfCompanyRegisterURL2: '',
        copyOfCompanyRegisterURL3: '',
        copyOfCompanyRegisterURL4: '',
        copyOfCompanyRegisterURL5: '',
        copyOfCompanyRegisterURL6: '',
        copyOfCompanyRegisterURL7: '',
        copyOfCompanyRegisterURL8: '',
        copyOfCompanyRegisterURL9: '',
        copyOfCompanyRegisterURL10: '',
        letterOfAttorneyURL: '',
      });

      const companyID = this.$route.query.companyID;
      this.postRequest('/companymgmt/history', { companyID: companyID })
        .then(e => {
          if (e.status === 'success') {
            let voicedxOnlyFlagView = '';
            let businessType = '';
            for (let i = 0; i < e.data.length; i++) {
              let adminName = [];
              let adminKanaName = [];

              if (typeof e.data[i]['adminName'] !== 'undefined') {
                adminName = e.data[i]['adminName'].split('_');
              }

              if (typeof e.data[i]['adminKanaName'] !== 'undefined') {
                adminKanaName = e.data[i]['adminKanaName'].split('_');
              }

              if (typeof e.data[i]['voicedxOnlyFlag'] === 'undefined') {
                voicedxOnlyFlagView = 'false';
              } else {
                voicedxOnlyFlagView = String(e.data[i]['voicedxOnlyFlag']);
              }

              if (typeof e.data[i]['businessType'] === 'undefined') {
                businessType = 'individual';
              } else {
                businessType = e.data[i]['businessType'];
              }

              // 「実質的支配者名」の処理 (#3532 max-depth対応)
              for (let idx = 0; idx < 4; ++idx) {
                let companyRulerNo = '';
                if (idx > 0) {
                  companyRulerNo = String(idx + 1);
                }
                if (typeof e.data[i]['companyRulerName' + companyRulerNo] === 'undefined') {
                  e.data[i]['companyRulerName' + companyRulerNo] = '';
                }
              }

              // 「実質的支配者住所」の処理 (#3532 max-depth対応)
              for (let idx = 0; idx < 4; ++idx) {
                let companyRulerNo = '';
                if (idx > 0) {
                  companyRulerNo = String(idx + 1);
                }
                if (typeof e.data[i]['companyRulerAddress' + companyRulerNo] === 'undefined') {
                  e.data[i]['companyRulerAddress' + companyRulerNo] = '';
                }
              }

              // 「実質的支配者生年月日」の処理 (#3532 max-depth対応)
              for (let idx = 0; idx < 4; ++idx) {
                let companyRulerNo = '';
                if (idx > 0) {
                  companyRulerNo = String(idx + 1);
                }
                if (typeof e.data[i]['companyRulerBirthDate' + companyRulerNo] === 'undefined') {
                  e.data[i]['companyRulerBirthDate' + companyRulerNo] = '';
                }
                e.data[i]['companyRulerBirthDate' + companyRulerNo] = e.data[i][
                  'companyRulerBirthDate' + companyRulerNo
                ].replace(/-/g, '');
              }

              // 「実質的支配者の法人との関係」の処理 (#3532 max-depth対応)
              for (let idx = 0; idx < 4; ++idx) {
                let companyRulerNo = '';
                if (idx > 0) {
                  companyRulerNo = String(idx + 1);
                }
                if (typeof e.data[i]['companyRelationship' + companyRulerNo] === 'undefined') {
                  e.data[i]['companyRelationship' + companyRulerNo] = '';
                }
              }

              let adminBirthDate = '';
              if (typeof e.data[i]['adminBirthDate'] === 'undefined') {
                adminBirthDate = '';
              } else {
                adminBirthDate = e.data[i]['adminBirthDate'].replace(/-/g, '');
              }

              let openDay = '';
              if (typeof e.data[i]['openDay'] === 'undefined' || e.data[i]['openDay'] === null) {
                openDay = '';
              } else {
                openDay = e.data[i]['openDay'].replace(/-/g, '');
              }

              // 職業を変換して値セット
              for (let j = 1; j < this.jobs.length; j++) {
                if (this.jobs[j].value === e.data[i]['adminJob']) {
                  e.data[i]['adminJob'] = this.jobs[j].label;
                }
              }

              // 対面フラグをstring化
              if (typeof e.data[i]['inPersonTransactionFlag'] === 'boolean') {
                e.data[i]['inPersonTransactionFlag'] = e.data[i]['inPersonTransactionFlag'].toString();
              } else {
                e.data[i]['inPersonTransactionFlag'] = '';
              }

              // 開通日、解約日、日付加工
              if (e.data[i]['startDate']) {
                e.data[i]['startDate'] = e.data[i]['startDate'].replaceAll('-', '');
              }
              if (e.data[i]['closeDate']) {
                e.data[i]['closeDate'] = e.data[i]['closeDate'].replaceAll('-', '');
              }

              this.historyList.push({
                value: e.data[i]['key'] ? e.data[i]['key'] : '',
                label: e.data[i]['key'] ? e.data[i]['key'] : '',
                companyID: e.data[i]['documentID'] ? e.data[i]['documentID'] : '',
                companyName: e.data[i]['companyName'] ? e.data[i]['companyName'] : '',
                customerID: e.data[i]['customerID'] ? e.data[i]['customerID'] : '',
                companyKanaName: e.data[i]['companyKanaName'] ? e.data[i]['companyKanaName'] : '',
                companyPostCode: e.data[i]['companyPostCode'] ? e.data[i]['companyPostCode'] : '',
                companyAddress1: e.data[i]['companyAddress1'] ? e.data[i]['companyAddress1'] : '',
                companyAddress2: e.data[i]['companyAddress2'] ? e.data[i]['companyAddress2'] : '',
                companyAddress3: e.data[i]['companyAddress3'] ? e.data[i]['companyAddress3'] : '',
                companyAddress4: e.data[i]['companyAddress4'] ? e.data[i]['companyAddress4'] : '',
                companyBusinessDetails: e.data[i]['companyBusinessDetails'] ? e.data[i]['companyBusinessDetails'] : '',
                companyNumber: e.data[i]['companyNumber'] ? e.data[i]['companyNumber'] : '',
                companyRulerFlag: e.data[i]['companyRulerFlag'] ? e.data[i]['companyRulerFlag'] : '',
                companyRulerName: e.data[i]['companyRulerName'] ? e.data[i]['companyRulerName'] : '',
                companyRulerAddress: e.data[i]['companyRulerAddress'] ? e.data[i]['companyRulerAddress'] : '',
                companyRulerBirthDate: e.data[i]['companyRulerBirthDate'] ? e.data[i]['companyRulerBirthDate'] : '',
                companyRelationship: e.data[i]['companyRelationship'] ? e.data[i]['companyRelationship'] : '',
                companyRulerName2: e.data[i]['companyRulerName2'] ? e.data[i]['companyRulerName2'] : '',
                companyRulerAddress2: e.data[i]['companyRulerAddress2'] ? e.data[i]['companyRulerAddress2'] : '',
                companyRulerBirthDate2: e.data[i]['companyRulerBirthDate2'] ? e.data[i]['companyRulerBirthDate2'] : '',
                companyRelationship2: e.data[i]['companyRelationship2'] ? e.data[i]['companyRelationship2'] : '',
                companyRulerName3: e.data[i]['companyRulerName3'] ? e.data[i]['companyRulerName3'] : '',
                companyRulerAddress3: e.data[i]['companyRulerAddress3'] ? e.data[i]['companyRulerAddress3'] : '',
                companyRulerBirthDate3: e.data[i]['companyRulerBirthDate3'] ? e.data[i]['companyRulerBirthDate3'] : '',
                companyRelationship3: e.data[i]['companyRelationship3'] ? e.data[i]['companyRelationship3'] : '',
                companyRulerName4: e.data[i]['companyRulerName4'] ? e.data[i]['companyRulerName4'] : '',
                companyRulerAddress4: e.data[i]['companyRulerAddress4'] ? e.data[i]['companyRulerAddress4'] : '',
                companyRulerBirthDate4: e.data[i]['companyRulerBirthDate4'] ? e.data[i]['companyRulerBirthDate4'] : '',
                companyRelationship4: e.data[i]['companyRelationship4'] ? e.data[i]['companyRelationship4'] : '',
                purposeOfUse: e.data[i]['purposeOfUse'] ? e.data[i]['purposeOfUse'] : '',
                adminLastName: adminName[0] ? adminName[0] : '',
                adminName: adminName[1] ? adminName[1] : '',
                adminLastKanaName: adminKanaName[0] ? adminKanaName[0] : '',
                adminKanaName: adminKanaName[1] ? adminKanaName[1] : '',
                adminPhoneNumber: e.data[i]['adminPhoneNumber'] ? e.data[i]['adminPhoneNumber'] : '',
                adminEmail: e.data[i]['adminEmail'] ? e.data[i]['adminEmail'] : '',
                adminBirthDate: adminBirthDate,
                adminJob: e.data[i]['adminJob'] ? e.data[i]['adminJob'] : '',
                adminPostCode: e.data[i]['adminPostCode'] ? e.data[i]['adminPostCode'] : '',
                adminAddress1: e.data[i]['adminAddress1'] ? e.data[i]['adminAddress1'] : '',
                adminAddress2: e.data[i]['adminAddress2'] ? e.data[i]['adminAddress2'] : '',
                adminAddress3: e.data[i]['adminAddress3'] ? e.data[i]['adminAddress3'] : '',
                adminAddress4: e.data[i]['adminAddress4'] ? e.data[i]['adminAddress4'] : '',
                invoicePostCode: e.data[i]['invoicePostCode'] ? e.data[i]['invoicePostCode'] : '',
                invoiceAddress1: e.data[i]['invoiceAddress1'] ? e.data[i]['invoiceAddress1'] : '',
                invoiceAddress2: e.data[i]['invoiceAddress2'] ? e.data[i]['invoiceAddress2'] : '',
                invoiceAddress3: e.data[i]['invoiceAddress3'] ? e.data[i]['invoiceAddress3'] : '',
                invoiceAddress4: e.data[i]['invoiceAddress4'] ? e.data[i]['invoiceAddress4'] : '',
                invoiceName: e.data[i]['invoiceName'] ? e.data[i]['invoiceName'] : '',
                invoiceKanaName: e.data[i]['invoiceKanaName'] ? e.data[i]['invoiceKanaName'] : '',
                invoicePhoneNumber: e.data[i]['invoicePhoneNumber'] ? e.data[i]['invoicePhoneNumber'] : '',
                invoiceDepartment: e.data[i]['invoiceDepartment'] ? e.data[i]['invoiceDepartment'] : '',
                businessType: businessType,
                billType: e.data[i]['billType'] ? e.data[i]['billType'] : '',
                inPersonTransactionFlag: e.data[i]['inPersonTransactionFlag']
                  ? e.data[i]['inPersonTransactionFlag']
                  : '',
                inPersonCertificateType: e.data[i]['inPersonCertificateType']
                  ? e.data[i]['inPersonCertificateType']
                  : '',
                documentCheckDay: e.data[i]['documentCheckDay'] ? e.data[i]['documentCheckDay'] : '',
                documentType: e.data[i]['documentType'] ? e.data[i]['documentType'] : '',
                voicedxOnlyFlag: e.data[i]['voicedxOnlyFlag'] ? e.data[i]['voicedxOnlyFlag'] : '',
                voicedxOnlyFlagView: voicedxOnlyFlagView,
                openDay: openDay,
                contractStatus: e.data[i]['contractStatus'] ? e.data[i]['contractStatus'] : '',
                soStatus: e.data[i]['soStatus'] ? e.data[i]['soStatus'] : '',
                responderName: e.data[i]['responderName'] ? e.data[i]['responderName'] : '',
                note: e.data[i]['note'] ? e.data[i]['note'] : '',
                cancelNumber: e.data[i]['cancelNumber'] ? e.data[i]['cancelNumber'] : '',
                cancelReason: e.data[i]['cancelReason'] ? e.data[i]['cancelReason'] : '',
                startDate: e.data[i]['startDate'] ? e.data[i]['startDate'] : '',
                closeDate: e.data[i]['closeDate'] ? e.data[i]['closeDate'] : '',
                salesChannelCode: e.data[i]['salesChannelCode'] ? e.data[i]['salesChannelCode'] : '',
                salesPersonCode: e.data[i]['salesPersonCode'] ? e.data[i]['salesPersonCode'] : '',
                salesPerson: e.data[i]['salesPerson'] ? e.data[i]['salesPerson'] : '',
                salesPersonKanaName: e.data[i]['salesPersonKanaName'] ? e.data[i]['salesPersonKanaName'] : '',
                salesPersonEmailAddress: e.data[i]['salesPersonEmailAddress']
                  ? e.data[i]['salesPersonEmailAddress']
                  : '',
                salesPersonPhoneNumber: e.data[i]['salesPersonPhoneNumber'] ? e.data[i]['salesPersonPhoneNumber'] : '',
                salesPersonDepartment: e.data[i]['salesPersonDepartment'] ? e.data[i]['salesPersonDepartment'] : '',
                expectedNumberOfPhoneNumber: e.data[i]['expectedNumberOfPhoneNumber']
                  ? e.data[i]['expectedNumberOfPhoneNumber']
                  : '',
                expectedMaxNumberOfPhoneNumber: e.data[i]['expectedMaxNumberOfPhoneNumber']
                  ? e.data[i]['expectedMaxNumberOfPhoneNumber']
                  : '',
                expectedMaxNumberOfOutgoingCalls: e.data[i]['expectedMaxNumberOfOutgoingCalls']
                  ? e.data[i]['expectedMaxNumberOfOutgoingCalls']
                  : '',
                expectedMaxNumberOfIncomingCalls: e.data[i]['expectedMaxNumberOfIncomingCalls']
                  ? e.data[i]['expectedMaxNumberOfIncomingCalls']
                  : '',
                signupResponderName: e.data[i]['signupResponderName'] ? e.data[i]['signupResponderName'] : '',
                signupResponderNameKana: e.data[i]['signupResponderNameKana']
                  ? e.data[i]['signupResponderNameKana']
                  : '',
                signupResponderMail: e.data[i]['signupResponderMail'] ? e.data[i]['signupResponderMail'] : '',
                signupResponderPhoneNumber: e.data[i]['signupResponderPhoneNumber']
                  ? e.data[i]['signupResponderPhoneNumber']
                  : '',
                signupResponderDepartment: e.data[i]['signupResponderDepartment']
                  ? e.data[i]['signupResponderDepartment']
                  : '',
              });
            }

            for (let i = 0; i < e.data2.length; i++) {
              this.certificateList.push({
                value: e.data2[i]['key'],
                DriverlicenseURL1: e.data2[i]['DriverlicenseURL1'],
                DriverlicenseURL2: e.data2[i]['DriverlicenseURL2'],
                MyNumberURL: e.data2[i]['MyNumberURL'],
                DrivingHistoryURL1: e.data2[i]['DrivingHistoryURL1'],
                DrivingHistoryURL2: e.data2[i]['DrivingHistoryURL2'],
                SealRegistrationURL: e.data2[i]['SealRegistrationURL'],
                FamilyRegisterURL: e.data2[i]['FamilyRegisterURL'],
                CertificateOfResidenceURL: e.data2[i]['CertificateOfResidenceURL'],
                copyOfCompanyRegisterURL1: e.data2[i]['copyOfCompanyRegisterURL1'],
                copyOfCompanyRegisterURL2: e.data2[i]['copyOfCompanyRegisterURL2'],
                copyOfCompanyRegisterURL3: e.data2[i]['copyOfCompanyRegisterURL3'],
                copyOfCompanyRegisterURL4: e.data2[i]['copyOfCompanyRegisterURL4'],
                copyOfCompanyRegisterURL5: e.data2[i]['copyOfCompanyRegisterURL5'],
                copyOfCompanyRegisterURL6: e.data2[i]['copyOfCompanyRegisterURL6'],
                copyOfCompanyRegisterURL7: e.data2[i]['copyOfCompanyRegisterURL7'],
                copyOfCompanyRegisterURL8: e.data2[i]['copyOfCompanyRegisterURL8'],
                copyOfCompanyRegisterURL9: e.data2[i]['copyOfCompanyRegisterURL9'],
                copyOfCompanyRegisterURL10: e.data2[i]['copyOfCompanyRegisterURL10'],
                letterOfAttorneyURL: e.data2[i]['letterOfAttorneyURL'],
              });
            }
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('更新履歴の取得'));
        });
    },
    open_file: async function (file_name) {
      await this.postRequest('/contract/download', { file_name: file_name })
        .then(e => {
          if (e.status === 'failed') {
            this.showErrorModal(messageContent.requireTry('データの取得'));
            return;
          }
          const blob = this.base64ImageToBlob(e.data);
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.download = file_name;
          a.href = url;
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('データの取得'));
        });
    },
    base64ImageToBlob(str) {
      // extract content type and base64 payload from original string
      const pos = str.indexOf(';base64,');
      const type = str.substring(5, pos);
      const b64 = str.substr(pos + 8);

      // decode base64
      const imageContent = window.atob(b64);

      // create an ArrayBuffer and a view (as unsigned 8-bit)
      const buffer = new ArrayBuffer(imageContent.length);
      const view = new Uint8Array(buffer);
      // fill the view, using the decoded base64
      for (let n = 0; n < imageContent.length; n++) {
        view[n] = imageContent.charCodeAt(n);
      }
      // convert ArrayBuffer to Blob
      const blob = new Blob([buffer], { type: type });
      return blob;
    },
    change_history() {
      for (let i = 0; i < this.historyList.length; i++) {
        if (this.formData.documents[0].type === this.historyList[i].value) {
          for (const key in this.companyInfoData) {
            this.companyInfoData[key] = this.historyList[i][key];
          }

          if (this.formData.documents[0].type === '') {
            this.flag = true;
          } else {
            this.flag = false;
          }

          if (this.companyInfoData.voicedxOnlyFlag) {
            this.companyInfoData.voicedxOnlyFlagView = 'COTOHA Voice DX Basicのみ';
          } else {
            this.companyInfoData.voicedxOnlyFlagView = 'COTOHA Voice DX Basic・COTOHA Call Center共用';
          }

          // soStatus
          if (this.companyInfoData.soStatus === 'review') {
            this.companyInfoData.soStatusView = '審査中';
          } else if (this.companyInfoData.soStatus === 'pass') {
            this.companyInfoData.soStatusView = '合格';
          } else if (this.companyInfoData.soStatus === 'fail') {
            this.companyInfoData.soStatusView = '審査不合格';
          }

          // 解約理由
          this.cancelReasonFlag = false;
          if (this.companyInfoData.contractStatus === 'close') {
            this.cancelReasonFlag = true;
            for (let i = 0; i < this.reasonList.length; i++) {
              if (this.reasonList[i].value === '0') {
                this.reasonList[i].label = 'その他:' + this.companyInfoData.cancelReason;
              }
            }
          }
          break;
        }
      }

      for (let i = 0; i < this.certificateList.length; i++) {
        if (this.formData.documents[0].type === this.certificateList[i].value) {
          this.open_documentID = this.$route.query.companyID;
          this.open_key = this.certificateList[i].value;

          for (const key in this.certificateInfo) {
            this.certificateInfo[key] = this.certificateList[i][key];
          }
          break;
        }
      }
    },
    replaceSpecialCharacter: function (string) {
      if (typeof string !== 'string') return string;
      return string.replace(/&|'|"|<|>|\r?\n|\r/g, '');
    },
    convertMessage(message, newValue) {
      const newMessage = message;
      // #2772
      return newMessage.replace(/\{{(.+?)\}}/g, this.replaceSpecialCharacter(newValue));
    },
    fetchCancelReasonDataHandler: async function () {
      await this.postRequest('/companymgmt/getcancelationinfo', {
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
      })
        .then(e => {
          const result = e.result;

          const keys = Object.keys(result);

          for (let i = 0; i < keys.length; i++) {
            const data = {
              value: keys[i],
              label: keys[i] + ':' + result[keys[i]],
            };
            this.reasonList.push(data);
          }
          const data = {
            value: '0',
            label: '',
          };
          this.reasonList.push(data);
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('契約者情報の取得'));
        });
    },
  },
};
</script>
